import cn from 'classnames';

import {
  Dream0Gauge,
  Dream100Gauge,
  Dream25Gauge,
  Dream50Gauge,
  Dream75Gauge,
  DreamRefill,
  DreamShampoo0,
  DreamShampoo100,
  DreamShampoo25,
  DreamShampoo50,
  DreamShampoo75,
  MagicPotion0Gauge,
  MagicPotion100Gauge,
  MagicPotion25Gauge,
  MagicPotion50Gauge,
  MagicPotion75Gauge,
  Potion0Gauge,
  Potion100Gauge,
  Potion25Gauge,
  Potion50Gauge,
  Potion75Gauge,
  PotionErrorGauge,
  PotionLoadingGauge,
} from '../../../foundations/assets';
import { IShampooIconProps, ShampooIconVariant } from '../ShampooIcon';

function PotionIcon({
  color,
  className,
  size = 30,
  rotate,
  flip,
  variant = ShampooIconVariant.OLDBIE_4,
  style,
}: IShampooIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    >
      {variant === ShampooIconVariant.OLDBIE_4 && (
        <svg width={size} height={size} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_dd_54_162098)">
            <path
              d="M19.3766 5.54333C17.5433 3.70975 15.0569 3.22368 13.8217 4.45901L13.5322 4.82338C10.6829 4.16576 7.56825 4.94655 5.3479 7.16723C1.92245 10.5932 1.92245 16.1489 5.3479 19.5749C8.77335 23.0008 14.3283 23.0008 17.7537 19.5749C19.9741 17.3542 20.7547 14.2398 20.0972 11.3894L20.4615 11.0998C21.6959 9.86517 21.2099 7.37764 19.3766 5.54406V5.54333Z"
              fill="#EFECF2"
            />
            <path
              d="M11.5512 22.4325C9.22972 22.4325 6.90821 21.5491 5.14088 19.7815C3.42852 18.0689 2.48584 15.7917 2.48584 13.3702C2.48584 10.9486 3.42852 8.67151 5.14088 6.9589C7.32164 4.77782 10.4033 3.86433 13.4168 4.49703L13.6147 4.25143C14.9613 2.90465 17.639 3.39145 19.5838 5.33574C21.5285 7.28075 22.0152 9.95964 20.6687 11.3064L20.6437 11.3284L20.4231 11.5044C21.0557 14.5183 20.1423 17.5997 17.9616 19.7815C16.1942 21.5491 13.8727 22.4325 11.5512 22.4325ZM11.5329 4.88706C9.31255 4.88706 7.17064 5.75876 5.55577 7.37386C3.9541 8.97577 3.07226 11.1048 3.07226 13.3702C3.07226 15.6356 3.9541 17.7646 5.55577 19.3665C8.86174 22.673 14.2407 22.673 17.5467 19.3665C19.6278 17.2851 20.4744 14.3277 19.8117 11.4545L19.77 11.2742L20.2655 10.8797C20.783 10.3533 20.9663 9.54468 20.7815 8.60113C20.5873 7.60846 20.0148 6.596 19.1689 5.74996C17.4587 4.03955 15.1629 3.55055 14.0406 4.65392L13.6462 5.14952L13.4659 5.10773C12.8223 4.9589 12.1736 4.88632 11.5322 4.88632L11.5329 4.88706Z"
              fill="#231815"
            />
            <path
              d="M11.5531 20.8753C15.6971 20.8753 19.0564 17.5154 19.0564 13.3709C19.0564 9.22629 15.6971 5.86646 11.5531 5.86646C7.40915 5.86646 4.0498 9.22629 4.0498 13.3709C4.0498 17.5154 7.40915 20.8753 11.5531 20.8753Z"
              fill="#F52F48"
            />
            <mask
              id="mask0_54_162098"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="4"
              y="5"
              width="16"
              height="16"
            >
              <path
                d="M11.5497 20.8768C15.6936 20.8768 19.053 17.517 19.053 13.3724C19.053 9.22788 15.6936 5.86804 11.5497 5.86804C7.40573 5.86804 4.04639 9.22788 4.04639 13.3724C4.04639 17.517 7.40573 20.8768 11.5497 20.8768Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_54_162098)">
              <path
                d="M8.738 20.2389C13.2637 20.2389 16.9326 16.5695 16.9326 12.0432C16.9326 7.51677 13.2637 3.84741 8.738 3.84741C4.21228 3.84741 0.543457 7.51677 0.543457 12.0432C0.543457 16.5695 4.21228 20.2389 8.738 20.2389Z"
                fill="#FF5D71"
              />
            </g>
            <path
              d="M18.9461 11.9341C17.4551 13.1299 15.2282 12.852 13.6515 11.2743C12.0747 9.69731 11.7976 7.47077 12.9917 5.9803L14.0458 4.65479C15.1681 3.55142 17.4639 4.04042 19.1741 5.75083C20.8843 7.46124 21.3739 9.75816 20.27 10.8806L18.9454 11.9341H18.9461Z"
              fill="#EFECF2"
            />
            <path
              d="M15.1193 9.80693C13.5653 8.25268 13.0199 6.21455 13.761 5.01294L12.992 5.97995C11.7972 7.47042 12.075 9.69696 13.6518 11.2739C15.2285 12.8509 17.4555 13.1288 18.9464 11.9338L19.9118 11.1654C18.7104 11.9066 16.6726 11.3612 15.1186 9.80693H15.1193Z"
              fill="#EFECF2"
            />
            <mask
              id="mask1_54_162098"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="12"
              y="5"
              width="8"
              height="8"
            >
              <path
                d="M15.112 9.809C13.5579 8.25475 13.0126 6.21663 13.7537 5.01501L12.9847 5.98202C11.7899 7.47249 12.0677 9.69903 13.6444 11.276C15.2212 12.853 17.4481 13.1308 18.9391 11.9358L19.9045 11.1675C18.7031 11.9087 16.6653 11.3633 15.1112 9.809H15.112Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask1_54_162098)">
              <path
                d="M17.2901 7.63329L12.0161 12.9081L15.5807 16.4732L20.8547 11.1984L17.2901 7.63329Z"
                fill="#B0A4BC"
              />
            </g>
            <path
              d="M21.8376 7.59439C22.5699 6.86198 22.1565 5.25934 20.9125 4.01594C19.6693 2.77254 18.0669 2.35832 17.3346 3.09072L15.7351 5.06433C15.0461 5.90817 15.2623 7.38617 16.4022 8.5262C17.542 9.66623 19.0206 9.88251 19.8635 9.19336L21.8369 7.59365L21.8376 7.59439Z"
              fill="#B16C3C"
            />
            <path
              d="M18.6911 9.87815C17.8621 9.87815 16.9406 9.48079 16.1937 8.73446C14.99 7.53064 14.6946 5.87375 15.5068 4.87962L17.1261 2.88402C17.9859 2.02404 19.7401 2.4302 21.1189 3.80924C21.7567 4.44707 22.2111 5.19853 22.3988 5.92434C22.6004 6.70513 22.4743 7.37229 22.0433 7.80264L22.0205 7.82317L20.0472 9.42287C19.6704 9.73079 19.1976 9.87888 18.6911 9.87888V9.87815ZM17.5505 3.28871L15.9613 5.24985C15.3404 6.01085 15.6183 7.3305 16.6078 8.32023C17.5974 9.30997 18.9169 9.58856 19.677 8.96759L21.6386 7.37742C21.9084 7.09809 21.9766 6.63475 21.8307 6.07023C21.6687 5.44413 21.2685 4.78871 20.704 4.22346C19.6023 3.12155 18.1633 2.69633 17.5505 3.28871Z"
              fill="#231815"
            />
            <path
              d="M21.6935 7.29376C21.1305 7.85681 19.7239 7.403 18.6228 6.30109C17.5218 5.19919 17.0674 3.79376 17.6303 3.22998C18.1933 2.66693 19.6 3.12074 20.701 4.22265C21.802 5.32382 22.2565 6.72998 21.6935 7.29376Z"
              fill="#DFB47E"
            />
            <path
              d="M8.59271 11.2963C9.24451 10.5405 9.28433 9.50634 8.68165 8.9864C8.07896 8.46647 7.06199 8.65765 6.41018 9.41342C5.75837 10.1692 5.71856 11.2034 6.32124 11.7233C6.92393 12.2432 7.9409 12.052 8.59271 11.2963Z"
              fill="white"
            />
          </g>
          <defs>
            <filter
              id="filter0_dd_54_162098"
              x="0.48584"
              y="0.433716"
              width="24.0142"
              height="24.0004"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.3625 0 0 0 0 0.483108 0 0 0 1 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_54_162098" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_54_162098" result="effect2_dropShadow_54_162098" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_54_162098" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.OLDBIE_3 && (
        <svg width={size} height={size} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_dd_54_162116)">
            <path
              d="M11.3625 22.5336C8.94093 22.5336 6.66381 21.591 4.9512 19.8788C1.41601 16.3444 1.41601 10.5934 4.9512 7.05903C7.13302 4.8777 10.2144 3.96514 13.2283 4.5977L13.4263 4.35215C14.0949 3.68368 15.0949 3.4396 16.243 3.66315C17.3486 3.87865 18.4688 4.50901 19.3962 5.43622C20.3236 6.36344 20.9541 7.48343 21.1697 8.58949C21.394 9.73733 21.1491 10.7378 20.4813 11.4056L20.4563 11.4276L20.2349 11.6035C20.8676 14.6168 19.9541 17.6975 17.773 19.8788C16.0604 21.591 13.784 22.5336 11.3618 22.5336H11.3625ZM11.3442 4.98764C9.12349 4.98764 6.98126 5.85915 5.36615 7.4739C2.0597 10.7796 2.0597 16.1582 5.36615 19.4639C6.96806 21.0655 9.09783 21.9473 11.3625 21.9473C13.6272 21.9473 15.7569 21.0655 17.3588 19.4639C19.4402 17.383 20.287 14.4262 19.6242 11.5536L19.5824 11.3733L20.078 10.979C20.5956 10.4527 20.7789 9.64424 20.5942 8.7009C20.3999 7.70845 19.8273 6.69621 18.9813 5.85035C18.1352 5.0045 17.1228 4.43205 16.1301 4.23854C15.1865 4.05456 14.3779 4.23781 13.8515 4.75529L13.4571 5.25078L13.2767 5.209C12.633 5.06021 11.9842 4.98764 11.3427 4.98764H11.3442Z"
              fill="#040000"
            />
            <path
              d="M18.4993 9.97771C17.6701 9.97771 16.7485 9.58044 16.0015 8.83427C14.7977 7.63072 14.5022 5.97419 15.3145 4.98027L16.934 2.98511C17.794 2.12533 19.5484 2.5314 20.9274 3.91013C22.3065 5.28886 22.7126 7.04214 21.8526 7.90265L21.8299 7.92318L19.8563 9.52253C19.4795 9.83038 19.0066 9.97844 18.5 9.97844L18.4993 9.97771ZM17.3592 3.38972L15.7698 5.35043C15.1488 6.11126 15.4267 7.43062 16.4164 8.42014C17.4062 9.40965 18.7258 9.68818 19.4861 9.06735L21.448 7.47753C22.0403 6.86476 21.6151 5.42666 20.5132 4.32499C19.948 3.75987 19.2925 3.35966 18.6664 3.19841C18.1019 3.05255 17.6386 3.12071 17.3592 3.39045V3.38972Z"
              fill="#040000"
            />
            <path
              d="M19.1884 5.54223C17.3552 3.70852 14.869 3.22242 13.6339 4.45784L13.3444 4.82224C10.4953 4.16457 7.38088 4.94542 5.1607 7.16625C1.7355 10.5925 1.7355 16.1486 5.1607 19.5748C8.5859 23.001 14.1404 23.001 17.5656 19.5748C19.7858 17.3539 20.5664 14.2394 19.9089 11.3887L20.2732 11.0991C21.5075 9.8644 21.0216 7.37668 19.1884 5.54297V5.54223Z"
              fill="#EFECF2"
            />
            <path
              d="M11.3645 22.4329C9.04319 22.4329 6.72185 21.5494 4.95465 19.7817C3.24241 18.069 2.2998 15.7917 2.2998 13.3699C2.2998 10.9482 3.24241 8.67092 4.95465 6.95818C7.13525 4.77694 10.2167 3.86338 13.23 4.49612L13.4279 4.2505C14.7743 2.90363 17.4519 3.39047 19.3965 5.3349C20.3237 6.26238 20.9541 7.3827 21.1696 8.48909C21.3938 9.63726 21.149 10.6381 20.4813 11.306L20.4564 11.328L20.235 11.504C20.8676 14.5181 19.9543 17.5997 17.7737 19.7817C16.0065 21.5494 13.6851 22.4329 11.3638 22.4329H11.3645ZM11.3462 4.88618C9.12602 4.88618 6.98426 5.75795 5.36951 7.37317C3.76796 8.97519 2.88619 11.1044 2.88619 13.3699C2.88619 15.6355 3.76796 17.7647 5.36951 19.3667C8.67524 22.6734 14.0538 22.6734 17.3595 19.3667C19.4405 17.2852 20.2871 14.3275 19.6244 11.4541L19.5827 11.2737L20.0782 10.8793C20.5956 10.3529 20.7789 9.54415 20.5942 8.60053C20.3999 7.60779 19.8275 6.59525 18.9816 5.74915C17.2716 4.03861 14.9759 3.54957 13.8537 4.65303L13.4594 5.14866L13.2791 5.10687C12.6355 4.95803 11.9868 4.88545 11.3455 4.88545L11.3462 4.88618Z"
              fill="#231815"
            />
            <path
              d="M11.3651 20.8753C15.5087 20.8753 18.8678 17.5152 18.8678 13.3703C18.8678 9.22544 15.5087 5.86536 11.3651 5.86536C7.2214 5.86536 3.8623 9.22544 3.8623 13.3703C3.8623 17.5152 7.2214 20.8753 11.3651 20.8753Z"
              fill="#E1E4E5"
            />
            <mask
              id="mask0_54_162116"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="2"
              y="9"
              width="19"
              height="14"
            >
              <path d="M20.1329 9.85596H2.58984V22.134H20.1329V9.85596Z" fill="white" />
            </mask>
            <g mask="url(#mask0_54_162116)">
              <path
                d="M11.3597 20.8761C15.5033 20.8761 18.8624 17.516 18.8624 13.3712C18.8624 9.22629 15.5033 5.86621 11.3597 5.86621C7.21603 5.86621 3.85693 9.22629 3.85693 13.3712C3.85693 17.516 7.21603 20.8761 11.3597 20.8761Z"
                fill="#F52F48"
              />
            </g>
            <mask
              id="mask1_54_162116"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="2"
              y="9"
              width="19"
              height="14"
            >
              <path d="M20.1329 9.85596H2.58984V22.134H20.1329V9.85596Z" fill="white" />
            </mask>
            <g mask="url(#mask1_54_162116)">
              <mask
                id="mask2_54_162116"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="3"
                y="5"
                width="16"
                height="16"
              >
                <path
                  d="M11.345 20.8756C15.4887 20.8756 18.8478 17.5155 18.8478 13.3707C18.8478 9.2258 15.4887 5.86572 11.345 5.86572C7.20138 5.86572 3.84229 9.2258 3.84229 13.3707C3.84229 17.5155 7.20138 20.8756 11.345 20.8756Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask2_54_162116)">
                <path
                  d="M8.53379 20.2379C13.0592 20.2379 16.7277 16.5683 16.7277 12.0416C16.7277 7.51484 13.0592 3.84521 8.53379 3.84521C4.0084 3.84521 0.339844 7.51484 0.339844 12.0416C0.339844 16.5683 4.0084 20.2379 8.53379 20.2379Z"
                  fill="#FF5D71"
                />
              </g>
            </g>
            <mask
              id="mask3_54_162116"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="3"
              y="5"
              width="16"
              height="16"
            >
              <path
                d="M11.3651 20.8759C15.5087 20.8759 18.8678 17.5158 18.8678 13.3709C18.8678 9.22605 15.5087 5.86597 11.3651 5.86597C7.2214 5.86597 3.8623 9.22605 3.8623 13.3709C3.8623 17.5158 7.2214 20.8759 11.3651 20.8759Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask3_54_162116)">
              <path
                d="M11.361 10.3213C15.1885 10.3213 18.2913 10.1138 18.2913 9.85791C18.2913 9.60199 15.1885 9.39453 11.361 9.39453C7.53346 9.39453 4.43066 9.60199 4.43066 9.85791C4.43066 10.1138 7.53346 10.3213 11.361 10.3213Z"
                fill="#FFACB7"
              />
            </g>
            <path
              d="M18.7498 11.9352C17.259 13.131 15.0322 12.8531 13.4556 11.2753C11.8789 9.69821 11.6019 7.47151 12.7959 5.98093L13.8499 4.65532C14.9721 3.55187 17.2678 4.04091 18.9778 5.75144C20.6878 7.46198 21.1775 9.75907 20.0736 10.8816L18.7491 11.9352H18.7498Z"
              fill="#EFECF2"
            />
            <path
              d="M14.9233 9.80752C13.3694 8.25316 12.824 6.21488 13.5651 5.01318L12.7962 5.98026C11.6014 7.47084 11.8792 9.69754 13.4559 11.2746C15.0325 12.8517 17.2593 13.1296 18.7502 11.9345L19.7155 11.1661C18.5141 11.9074 16.4765 11.3619 14.9225 9.80752H14.9233Z"
              fill="#EFECF2"
            />
            <mask
              id="mask4_54_162116"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="12"
              y="5"
              width="8"
              height="8"
            >
              <path
                d="M14.9277 9.80655C13.3738 8.25218 12.8284 6.21391 13.5695 5.01221L12.8006 5.97929C11.6058 7.46986 11.8836 9.69657 13.4603 11.2737C15.0369 12.8508 17.2637 13.1286 18.7545 11.9335L19.7199 11.1652C18.5185 11.9064 16.4809 11.3609 14.9269 9.80655H14.9277Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask4_54_162116)">
              <path
                d="M17.1003 7.63401L11.8267 12.9092L15.391 16.4745L20.6646 11.1993L17.1003 7.63401Z"
                fill="#B0A4BC"
              />
            </g>
            <path
              d="M8.40057 11.2966C9.05233 10.5407 9.09214 9.50649 8.4895 8.98651C7.88685 8.46654 6.86996 8.65774 6.2182 9.41356C5.56644 10.1694 5.52662 11.2036 6.12927 11.7236C6.73191 12.2436 7.74881 12.0524 8.40057 11.2966Z"
              fill="white"
            />
            <path
              d="M21.6428 7.59511C22.375 6.86265 21.9616 5.25989 20.7178 4.0164C19.4746 2.77291 17.8723 2.35865 17.1401 3.09111L15.5407 5.06486C14.8517 5.90877 15.068 7.38688 16.2078 8.52699C17.3475 9.66711 18.8259 9.8834 19.6689 9.1942L21.642 7.59438L21.6428 7.59511Z"
              fill="#B16C3C"
            />
            <path
              d="M18.4975 9.87803C17.6685 9.87803 16.7471 9.48064 16.0002 8.73425C14.7967 7.53035 14.5013 5.87334 15.3134 4.87913L16.9326 2.88339C17.3636 2.45227 18.0306 2.32616 18.8105 2.52779C19.5361 2.71548 20.2867 3.17006 20.9251 3.80794C22.3038 5.18707 22.7099 6.94087 21.8501 7.80163L21.8274 7.82216L19.8542 9.42199C19.4775 9.72993 19.0047 9.87803 18.4982 9.87803H18.4975ZM17.357 3.28737L15.7679 5.24866C15.1471 6.00971 15.4249 7.32946 16.4144 8.31927C17.4039 9.30908 18.7232 9.58769 19.4826 8.96668L21.4441 7.37638C22.0363 6.76417 21.6112 5.32491 20.5095 4.22219C19.9444 3.6569 19.2891 3.25658 18.6631 3.09528C18.0988 2.94937 17.6355 3.01756 17.3562 3.28737H17.357Z"
              fill="#231815"
            />
            <path
              d="M21.5018 7.29359C20.9389 7.85668 19.5323 7.40283 18.4313 6.30085C17.3304 5.19886 16.876 3.79333 17.4389 3.22951C18.0018 2.66642 19.4084 3.12026 20.5093 4.22225C21.6103 5.3235 22.0647 6.72976 21.5018 7.29359Z"
              fill="#DFB47E"
            />
          </g>
          <defs>
            <filter
              id="filter0_dd_54_162116"
              x="0.299805"
              y="0.434082"
              width="24.0029"
              height="24.0996"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.3625 0 0 0 0 0.483108 0 0 0 0.5 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_54_162116" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_54_162116" result="effect2_dropShadow_54_162116" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_54_162116" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.OLDBIE_2 && (
        <svg width={size} height={size} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_dd_54_162134)">
            <path
              d="M11.1628 22.5336C8.74123 22.5336 6.4641 21.591 4.75149 19.8788C1.2163 16.3444 1.2163 10.5934 4.75149 7.05903C6.93331 4.8777 10.0147 3.96514 13.0286 4.5977L13.2266 4.35215C13.8952 3.68368 14.8952 3.4396 16.0433 3.66315C17.1489 3.87865 18.2691 4.50901 19.1965 5.43622C20.1239 6.36344 20.7544 7.48343 20.97 8.58949C21.1943 9.73733 20.9494 10.7378 20.2815 11.4056L20.2566 11.4276L20.0352 11.6035C20.6679 14.6168 19.7544 17.6975 17.5733 19.8788C15.8607 21.591 13.5843 22.5336 11.162 22.5336H11.1628ZM11.1445 4.98764C8.92378 4.98764 6.78155 5.85915 5.16645 7.4739C1.86 10.7796 1.86 16.1582 5.16645 19.4639C6.76835 21.0655 8.89812 21.9473 11.1628 21.9473C13.4274 21.9473 15.5572 21.0655 17.1591 19.4639C19.2405 17.383 20.0873 14.4262 19.4245 11.5536L19.3827 11.3733L19.8783 10.979C20.3959 10.4527 20.5792 9.64424 20.3945 8.7009C20.2002 7.70845 19.6276 6.69621 18.7815 5.85035C17.9355 5.0045 16.923 4.43205 15.9304 4.23854C14.9868 4.05456 14.1782 4.23781 13.6518 4.75529L13.2574 5.25078L13.077 5.209C12.4333 5.06021 11.7845 4.98764 11.143 4.98764H11.1445Z"
              fill="#040000"
            />
            <path
              d="M18.2996 9.97771C17.4704 9.97771 16.5488 9.58044 15.8018 8.83427C14.598 7.63072 14.3025 5.97419 15.1148 4.98027L16.7343 2.98511C17.5943 2.12533 19.3487 2.5314 20.7277 3.91013C22.1067 5.28886 22.5129 7.04214 21.6529 7.90265L21.6302 7.92318L19.6566 9.52253C19.2798 9.83038 18.8069 9.97844 18.3003 9.97844L18.2996 9.97771ZM17.1595 3.38972L15.5701 5.35043C14.9491 6.11126 15.227 7.43062 16.2167 8.42014C17.2065 9.40965 18.5261 9.68818 19.2864 9.06735L21.2482 7.47753C21.8406 6.86476 21.4154 5.42666 20.3135 4.32499C19.7482 3.75987 19.0928 3.35966 18.4667 3.19841C17.9022 3.05255 17.4389 3.12071 17.1595 3.39045V3.38972Z"
              fill="#040000"
            />
            <path
              d="M18.988 5.54452C17.1544 3.71135 14.6676 3.22539 13.4322 4.46045L13.1426 4.82474C10.2929 4.16726 7.17783 4.94788 4.95716 7.16807C1.53121 10.5933 1.53121 16.1478 4.95716 19.573C8.38311 22.9982 13.9388 22.9982 17.3648 19.573C19.5855 17.3528 20.3662 14.2391 19.7086 11.3893L20.073 11.0998C21.3076 9.86542 20.8215 7.37843 18.988 5.54526V5.54452Z"
              fill="#EFECF2"
            />
            <path
              d="M11.1628 22.4335C8.74123 22.4335 6.4641 21.4909 4.75149 19.7787C1.2163 16.2443 1.2163 10.4933 4.75149 6.95894C6.93258 4.7776 10.0147 3.86504 13.0286 4.4976L13.2266 4.25205C13.8952 3.58358 14.8952 3.3395 16.0433 3.56306C17.1489 3.77855 18.2691 4.40891 19.1965 5.33613C20.1239 6.26334 20.7544 7.38333 20.97 8.48939C21.1943 9.63723 20.9494 10.6377 20.2816 11.3055L20.2566 11.3275L20.0352 11.5034C20.6679 14.5167 19.7544 17.5974 17.5733 19.7787C15.8607 21.4909 13.5843 22.4335 11.162 22.4335H11.1628ZM11.1445 4.88754C8.92378 4.88754 6.78155 5.75905 5.16645 7.3738C1.86 10.6795 1.86 16.0581 5.16645 19.3638C6.76835 20.9654 8.89812 21.8472 11.1628 21.8472C13.4274 21.8472 15.5572 20.9654 17.1591 19.3638C19.2405 17.2829 20.0873 14.3261 19.4245 11.4535L19.3827 11.2732L19.8783 10.8789C20.3959 10.3526 20.5792 9.54414 20.3945 8.6008C20.2002 7.60835 19.6276 6.59611 18.7816 5.75026C17.9355 4.9044 16.923 4.33195 15.9304 4.13771C14.9868 3.95373 14.1782 4.13698 13.6525 4.65446L13.2581 5.14995L13.0777 5.10817C12.434 4.95938 11.7852 4.88681 11.1437 4.88681L11.1445 4.88754Z"
              fill="#231815"
            />
            <path
              d="M11.1587 20.872C15.3033 20.872 18.6631 17.5129 18.6631 13.3692C18.6631 9.22555 15.3033 5.86646 11.1587 5.86646C7.01413 5.86646 3.6543 9.22555 3.6543 13.3692C3.6543 17.5129 7.01413 20.872 11.1587 20.872Z"
              fill="#E1E4E5"
            />
            <mask
              id="mask0_54_162134"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="2"
              y="14"
              width="18"
              height="9"
            >
              <path d="M19.9278 14.038H2.38086V22.1388H19.9278V14.038Z" fill="white" />
            </mask>
            <g mask="url(#mask0_54_162134)">
              <path
                d="M11.1567 20.8707C15.3013 20.8707 18.6611 17.5116 18.6611 13.368C18.6611 9.22433 15.3013 5.86523 11.1567 5.86523C7.01218 5.86523 3.65234 9.22433 3.65234 13.368C3.65234 17.5116 7.01218 20.8707 11.1567 20.8707Z"
                fill="#F52F48"
              />
            </g>
            <mask
              id="mask1_54_162134"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="2"
              y="14"
              width="18"
              height="9"
            >
              <path d="M19.9278 14.038H2.38086V22.1293H19.9278V14.038Z" fill="white" />
            </mask>
            <g mask="url(#mask1_54_162134)">
              <mask
                id="mask2_54_162134"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="3"
                y="5"
                width="16"
                height="16"
              >
                <path
                  d="M11.1611 20.8732C15.3057 20.8732 18.6655 17.5141 18.6655 13.3704C18.6655 9.22677 15.3057 5.86768 11.1611 5.86768C7.01657 5.86768 3.65674 9.22677 3.65674 13.3704C3.65674 17.5141 7.01657 20.8732 11.1611 20.8732Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask2_54_162134)">
                <path
                  d="M8.34077 20.2358C12.8672 20.2358 16.5365 16.5672 16.5365 12.0418C16.5365 7.51646 12.8672 3.8479 8.34077 3.8479C3.81438 3.8479 0.14502 7.51646 0.14502 12.0418C0.14502 16.5672 3.81438 20.2358 8.34077 20.2358Z"
                  fill="#FF5D71"
                />
              </g>
            </g>
            <mask
              id="mask3_54_162134"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="3"
              y="5"
              width="16"
              height="16"
            >
              <path
                d="M11.167 20.8715C15.3116 20.8715 18.6714 17.5124 18.6714 13.3687C18.6714 9.22506 15.3116 5.86597 11.167 5.86597C7.02243 5.86597 3.6626 9.22506 3.6626 13.3687C3.6626 17.5124 7.02243 20.8715 11.167 20.8715Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask3_54_162134)">
              <path
                d="M11.1727 14.5029C15.4857 14.5029 18.982 14.2955 18.982 14.0397C18.982 13.7838 15.4857 13.5764 11.1727 13.5764C6.85966 13.5764 3.36328 13.7838 3.36328 14.0397C3.36328 14.2955 6.85966 14.5029 11.1727 14.5029Z"
                fill="#FFACB7"
              />
            </g>
            <path
              d="M18.5516 11.9329C17.0604 13.1284 14.8331 12.8506 13.2562 11.2732C11.6792 9.69656 11.402 7.47051 12.5963 5.98037L13.6506 4.65515C14.773 3.55202 17.0692 4.04091 18.7796 5.75095C20.49 7.46098 20.9798 9.7574 19.8757 10.8796L18.5509 11.9329H18.5516Z"
              fill="#EFECF2"
            />
            <path
              d="M14.7242 9.80612C13.17 8.25221 12.6245 6.21453 13.3657 5.01318L12.5966 5.97998C11.4016 7.47012 11.6795 9.69617 13.2565 11.2728C14.8334 12.8494 17.0607 13.1272 18.5519 11.9325L19.5175 11.1643C18.3158 11.9054 16.2777 11.36 14.7235 9.80612H14.7242Z"
              fill="#EFECF2"
            />
            <mask
              id="mask4_54_162134"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="11"
              y="5"
              width="9"
              height="8"
            >
              <path
                d="M14.7232 9.80514C13.169 8.25123 12.6235 6.21356 13.3647 5.01221L12.5957 5.979C11.4006 7.46914 11.6785 9.69519 13.2555 11.2718C14.8325 12.8485 17.0597 13.1263 18.5509 11.9315L19.5165 11.1633C18.3149 11.9044 16.2767 11.3591 14.7225 9.80514H14.7232Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask4_54_162134)">
              <path d="M16.9013 7.6314L11.6265 12.905L15.1915 16.4693L20.4663 11.1957L16.9013 7.6314Z" fill="#B0A4BC" />
            </g>
            <path
              d="M8.2016 11.2944C8.8535 10.5388 8.89333 9.50491 8.29055 8.98509C7.68777 8.46527 6.67066 8.65641 6.01875 9.41201C5.36685 10.1676 5.32703 11.2015 5.9298 11.7214C6.53258 12.2412 7.5497 12.0501 8.2016 11.2944Z"
              fill="white"
            />
            <path
              d="M21.4445 7.59368C22.1769 6.86144 21.7634 5.25915 20.5193 4.01602C19.2759 2.7729 17.6732 2.35876 16.9408 3.09101L15.3411 5.06418C14.652 5.90784 14.8683 7.38552 16.0083 8.5253C17.1483 9.66507 18.6271 9.8813 19.4702 9.1923L21.4438 7.59295L21.4445 7.59368Z"
              fill="#B16C3C"
            />
            <path
              d="M18.2986 9.87688C17.4694 9.87688 16.5479 9.47961 15.8008 8.73344C14.597 7.52989 14.3015 5.87336 15.1138 4.87944L16.7333 2.88428C17.5933 2.0245 19.3477 2.43057 20.7267 3.8093C22.1058 5.18803 22.5119 6.94131 21.652 7.80182L21.6292 7.82235L19.6556 9.4217C19.2788 9.72955 18.8059 9.87761 18.2993 9.87761L18.2986 9.87688ZM17.1586 3.28889L15.5691 5.2496C14.9481 6.01043 15.226 7.32979 16.2157 8.3193C17.2055 9.30882 18.5251 9.58735 19.2847 8.96652L21.2465 7.3767C21.8389 6.76393 21.4137 5.32583 20.3118 4.22416C19.7465 3.65904 19.0911 3.25883 18.465 3.09758C17.9005 2.95172 17.4371 3.01988 17.1578 3.28962L17.1586 3.28889Z"
              fill="#231815"
            />
            <path
              d="M21.303 7.2933C20.74 7.85623 19.3331 7.40252 18.2319 6.30085C17.1307 5.19919 16.6762 3.79407 17.2392 3.23041C17.8023 2.66749 19.2092 3.1212 20.3104 4.22286C21.4115 5.3238 21.8661 6.72964 21.303 7.2933Z"
              fill="#DFB47E"
            />
          </g>
          <defs>
            <filter
              id="filter0_dd_54_162134"
              x="0.100097"
              y="0.434082"
              width="24.0029"
              height="24.0996"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.3625 0 0 0 0 0.483108 0 0 0 0.5 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_54_162134" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="0.75" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_54_162134" result="effect2_dropShadow_54_162134" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_54_162134" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.OLDBIE_1 && (
        <svg width={size} height={size} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_dd_54_162152)">
            <path
              d="M11.5539 22.5338C9.13234 22.5338 6.85521 21.5911 5.1426 19.8789C1.60741 16.3445 1.60741 10.5936 5.1426 7.05916C7.32442 4.87782 10.4058 3.96526 13.4197 4.59782L13.6177 4.35227C14.2863 3.6838 15.2863 3.43972 16.4344 3.66328C17.54 3.87877 18.6602 4.50913 19.5876 5.43635C20.515 6.36356 21.1455 7.48355 21.3611 8.58961C21.5854 9.73745 21.3406 10.738 20.6727 11.4057L20.6477 11.4277L20.4263 11.6036C21.059 14.6169 20.1455 17.6976 17.9645 19.8789C16.2518 21.5911 13.9754 22.5338 11.5532 22.5338H11.5539ZM11.5356 4.98776C9.31489 4.98776 7.17266 5.85927 5.55756 7.47402C2.25111 10.7797 2.25111 16.1583 5.55756 19.4641C7.15947 21.0656 9.28923 21.9474 11.5539 21.9474C13.8186 21.9474 15.9483 21.0656 17.5502 19.4641C19.6316 17.3831 20.4784 14.4263 19.8156 11.5538L19.7738 11.3735L20.2694 10.9791C20.787 10.4528 20.9703 9.64436 20.7856 8.70102C20.5913 7.70857 20.0187 6.69633 19.1727 5.85048C18.3266 5.00462 17.3142 4.43217 16.3215 4.23866C15.3779 4.05468 14.5693 4.23793 14.0429 4.75541L13.6485 5.2509L13.4681 5.20912C12.8244 5.06033 12.1756 4.98776 11.5341 4.98776H11.5356Z"
              fill="#040000"
            />
            <path
              d="M18.6907 9.97783C17.8615 9.97783 16.9399 9.58056 16.1929 8.83439C14.9891 7.63084 14.6936 5.97431 15.5059 4.9804L17.1254 2.98523C17.9854 2.12545 19.7398 2.53152 21.1188 3.91025C22.4979 5.28898 22.904 7.04226 22.044 7.90278L22.0213 7.9233L20.0477 9.52265C19.6709 9.8305 19.198 9.97857 18.6914 9.97857L18.6907 9.97783ZM17.5506 3.38984L15.9612 5.35055C15.3402 6.11138 15.6181 7.43074 16.6078 8.42026C17.5976 9.40978 18.9172 9.68831 19.6775 9.06748L21.6394 7.47765C22.2317 6.86488 21.8065 5.42678 20.7046 4.32512C20.1394 3.75999 19.4839 3.35979 18.8578 3.19853C18.2933 3.05267 17.83 3.12084 17.5506 3.39057V3.38984Z"
              fill="#040000"
            />
            <path
              d="M19.3696 5.54185C17.5364 3.70854 15.0501 3.22254 13.8151 4.45769L13.5255 4.82201C10.6765 4.16448 7.56204 4.94516 5.34185 7.16551C1.91665 10.591 1.91665 16.1459 5.34185 19.5713C8.76705 22.9968 14.3215 22.9968 17.7467 19.5713C19.9669 17.351 20.7476 14.2371 20.0901 11.387L20.4544 11.0975C21.6887 9.86306 21.2027 7.37589 19.3696 5.54258V5.54185Z"
              fill="#EFECF2"
            />
            <path
              d="M11.5457 22.4332C9.12466 22.4332 6.84803 21.4905 5.1358 19.7781C3.42356 18.0658 2.48096 15.789 2.48096 13.3678C2.48096 10.9466 3.42356 8.66978 5.1358 6.95742C7.3164 4.77592 10.3978 3.8633 13.4111 4.4959L13.609 4.25034C14.9555 2.90376 17.633 3.39049 19.5776 5.33449C21.5222 7.27922 22.0089 9.95771 20.6624 11.3043L20.6375 11.3263L20.4162 11.5022C21.0487 14.5157 20.1354 17.5966 17.9548 19.7781C16.2426 21.4905 13.9667 22.4332 11.5449 22.4332H11.5457ZM11.5274 4.88587C9.30717 4.88587 7.16541 5.75745 5.55066 7.37231C3.94911 8.97398 3.06734 11.1027 3.06734 13.3678C3.06734 15.6328 3.94911 17.7616 5.55066 19.3632C7.15222 20.9649 9.28078 21.8467 11.5457 21.8467C13.8106 21.8467 15.9391 20.9649 17.5407 19.3632C19.6216 17.2822 20.4682 14.3251 19.8056 11.4524L19.7638 11.272L20.2593 10.8777C20.7768 10.3513 20.96 9.54282 20.7753 8.59941C20.5811 7.60688 20.0086 6.59457 19.1628 5.74865C17.4527 4.03849 15.1571 3.54956 14.0349 4.65277L13.6405 5.1483L13.4602 5.10652C12.8167 4.95771 12.168 4.88514 11.5266 4.88514L11.5274 4.88587Z"
              fill="#231815"
            />
            <path
              d="M11.5472 20.871C15.6908 20.871 19.0499 17.5116 19.0499 13.3677C19.0499 9.22372 15.6908 5.86438 11.5472 5.86438C7.40353 5.86438 4.04443 9.22372 4.04443 13.3677C4.04443 17.5116 7.40353 20.871 11.5472 20.871Z"
              fill="#E1E4E5"
            />
            <mask
              id="mask0_54_162152"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="2"
              y="17"
              width="19"
              height="6"
            >
              <path d="M20.3131 17.2639H2.77002V22.1393H20.3131V17.2639Z" fill="white" />
            </mask>
            <g mask="url(#mask0_54_162152)">
              <path
                d="M11.5399 20.8709C15.6835 20.8709 19.0426 17.5115 19.0426 13.3676C19.0426 9.2236 15.6835 5.86426 11.5399 5.86426C7.3962 5.86426 4.03711 9.2236 4.03711 13.3676C4.03711 17.5115 7.3962 20.8709 11.5399 20.8709Z"
                fill="#F52F48"
              />
            </g>
            <mask
              id="mask1_54_162152"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="2"
              y="17"
              width="19"
              height="6"
            >
              <path d="M20.3131 17.2639H2.77002V22.1393H20.3131V17.2639Z" fill="white" />
            </mask>
            <g mask="url(#mask1_54_162152)">
              <mask
                id="mask2_54_162152"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="5"
                width="16"
                height="16"
              >
                <path
                  d="M11.533 20.8689C15.6767 20.8689 19.0358 17.5096 19.0358 13.3656C19.0358 9.22165 15.6767 5.8623 11.533 5.8623C7.38937 5.8623 4.03027 9.22165 4.03027 13.3656C4.03027 17.5096 7.38937 20.8689 11.533 20.8689Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask2_54_162152)">
                <path
                  d="M8.72178 20.232C13.2472 20.232 16.9157 16.5632 16.9157 12.0374C16.9157 7.51172 13.2472 3.8429 8.72178 3.8429C4.19639 3.8429 0.527832 7.51172 0.527832 12.0374C0.527832 16.5632 4.19639 20.232 8.72178 20.232Z"
                  fill="#FF5D71"
                />
              </g>
            </g>
            <mask
              id="mask3_54_162152"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="4"
              y="5"
              width="16"
              height="16"
            >
              <path
                d="M11.5452 20.8726C15.6889 20.8726 19.048 17.5132 19.048 13.3693C19.048 9.22531 15.6889 5.86597 11.5452 5.86597C7.40158 5.86597 4.04248 9.22531 4.04248 13.3693C4.04248 17.5132 7.40158 20.8726 11.5452 20.8726Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask3_54_162152)">
              <path
                d="M11.5488 17.7278C15.2556 17.7278 18.2606 17.5204 18.2606 17.2645C18.2606 17.0087 15.2556 16.8013 11.5488 16.8013C7.84192 16.8013 4.83691 17.0087 4.83691 17.2645C4.83691 17.5204 7.84192 17.7278 11.5488 17.7278Z"
                fill="#FFACB7"
              />
            </g>
            <path
              d="M18.9359 11.9325C17.445 13.128 15.2182 12.8502 13.6416 11.2727C12.065 9.696 11.7879 7.46978 12.9819 5.97953L14.0359 4.65421C15.1581 3.551 17.4538 4.03993 19.1638 5.75009C20.8739 7.46025 21.3635 9.75684 20.2596 10.8791L18.9351 11.9325H18.9359Z"
              fill="#EFECF2"
            />
            <path
              d="M15.1093 9.80647C13.5554 8.25244 13.0101 6.21462 13.7511 5.01318L12.9822 5.98005C11.7875 7.4703 12.0653 9.69651 13.6419 11.2733C15.2185 12.85 17.4453 13.1278 18.9362 11.933L19.9015 11.1648C18.7002 11.9059 16.6625 11.3605 15.1086 9.80647H15.1093Z"
              fill="#EFECF2"
            />
            <mask
              id="mask4_54_162152"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="12"
              y="5"
              width="8"
              height="8"
            >
              <path
                d="M15.1074 9.80549C13.5535 8.25147 13.0081 6.21364 13.7492 5.01221L12.9803 5.97907C11.7855 7.46932 12.0633 9.69554 13.6399 11.2723C15.2166 12.849 17.4434 13.1269 18.9342 11.932L19.8996 11.1638C18.6982 11.9049 16.6605 11.3595 15.1066 9.80549H15.1074Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask4_54_162152)">
              <path
                d="M17.2849 7.63419L12.0112 12.9082L15.5755 16.4728L20.8492 11.1987L17.2849 7.63419Z"
                fill="#B0A4BC"
              />
            </g>
            <path
              d="M8.58697 11.2945C9.2387 10.5389 9.27851 9.50489 8.67589 8.98504C8.07326 8.4652 7.05641 8.65634 6.40467 9.41197C5.75294 10.1676 5.71313 11.2016 6.31576 11.7214C6.91838 12.2413 7.93524 12.0501 8.58697 11.2945Z"
              fill="white"
            />
            <path
              d="M21.8322 7.59404C22.5645 6.86174 22.1511 5.25934 20.9072 4.01612C19.6641 2.7729 18.0618 2.35874 17.3296 3.09103L15.7302 5.06435C15.0412 5.90807 15.2574 7.38586 16.3972 8.52572C17.537 9.66558 19.0154 9.88183 19.8583 9.19278L21.8315 7.59331L21.8322 7.59404Z"
              fill="#B16C3C"
            />
            <path
              d="M18.6869 9.8764C17.8579 9.8764 16.9366 9.47909 16.1897 8.73287C14.9861 7.52923 14.6908 5.87258 15.5029 4.8786L17.122 2.88329C17.553 2.45226 18.22 2.32618 18.9999 2.52777C19.7256 2.71542 20.4761 3.1699 21.1146 3.80764C22.4933 5.18647 22.8994 6.93988 22.0396 7.80045L22.0169 7.82098L20.0437 9.42045C19.6669 9.72832 19.1942 9.8764 18.6877 9.8764H18.6869ZM17.5464 3.28719L15.9573 5.24804C15.3365 6.00893 15.6143 7.32838 16.6038 8.31797C17.5933 9.30756 18.9127 9.58612 19.6721 8.96524L21.6335 7.3753C22.2258 6.76322 21.8006 5.32428 20.699 4.2218C20.1338 3.65663 19.4786 3.2564 18.8526 3.09513C18.2882 2.94926 17.825 3.01743 17.5457 3.28719H17.5464Z"
              fill="#231815"
            />
            <path
              d="M21.6883 7.29264C21.1254 7.85561 19.7188 7.40186 18.6179 6.30012C17.5169 5.19837 17.0625 3.79316 17.6254 3.22946C18.1883 2.66649 19.5949 3.12023 20.6959 4.22198C21.7968 5.32299 22.2512 6.72894 21.6883 7.29264Z"
              fill="#DFB47E"
            />
          </g>
          <defs>
            <filter
              id="filter0_dd_54_162152"
              x="0.480957"
              y="0.434082"
              width="24.019"
              height="24.0997"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.3625 0 0 0 0 0.483108 0 0 0 0.3 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_54_162152" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="0.65" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_54_162152" result="effect2_dropShadow_54_162152" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_54_162152" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.OLDBIE_0 && (
        <svg width={size} height={size} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_54_162170)">
            <path
              d="M19.1884 5.54269C17.3552 3.70952 14.869 3.22355 13.6339 4.45862L13.3444 4.82291C10.4953 4.16543 7.38088 4.94605 5.1607 7.16624C1.7355 10.5914 1.7355 16.1459 5.1607 19.5711C8.5859 22.9963 14.1404 22.9963 17.5656 19.5711C19.7858 17.3509 20.5664 14.2373 19.9089 11.3874L20.2732 11.0979C21.5075 9.86359 21.0216 7.3766 19.1884 5.54343V5.54269Z"
              fill="#EFECF2"
            />
            <path
              d="M11.3645 22.4329C8.9435 22.4329 6.66688 21.4903 4.95465 19.7781C3.24241 18.0659 2.2998 15.7892 2.2998 13.3682C2.2998 10.9472 3.24241 8.67057 4.95465 6.95834C7.13598 4.777 10.2167 3.86445 13.23 4.497L13.4279 4.25146C14.7743 2.90498 17.4519 3.39094 19.3965 5.33553C21.3411 7.28012 21.8278 9.95841 20.4813 11.3049L20.4564 11.3269L20.235 11.5028C20.8676 14.5161 19.9543 17.5968 17.7737 19.7781C16.0614 21.4903 13.7855 22.4329 11.3638 22.4329H11.3645ZM11.3462 4.88695C9.12602 4.88695 6.98426 5.75846 5.36951 7.3732C3.76796 8.97476 2.88619 11.1041 2.88619 13.3682C2.88619 15.6324 3.76796 17.7617 5.36951 19.3632C6.97106 20.9648 9.09963 21.8466 11.3645 21.8466C13.6294 21.8466 15.758 20.9648 17.3595 19.3632C19.4405 17.2823 20.2871 14.3255 19.6244 11.453L19.5827 11.2726L20.0782 10.8783C21.1813 9.75611 20.6924 7.4597 18.9824 5.74966C17.2723 4.03963 14.9766 3.55073 13.8544 4.65386L13.4601 5.14935L13.2798 5.10757C12.6362 4.95878 11.9876 4.88621 11.3462 4.88621V4.88695Z"
              fill="#231815"
            />
            <path
              d="M11.3651 20.872C15.5087 20.872 18.8678 17.5129 18.8678 13.3692C18.8678 9.22555 15.5087 5.86646 11.3651 5.86646C7.2214 5.86646 3.8623 9.22555 3.8623 13.3692C3.8623 17.5129 7.2214 20.872 11.3651 20.872Z"
              fill="#E1E4E5"
            />
            <path
              d="M18.7498 11.9329C17.259 13.1284 15.0322 12.8506 13.4556 11.2732C11.8789 9.69583 11.6019 7.47051 12.7959 5.98037L13.8499 4.65515C14.9721 3.55202 17.2678 4.04091 18.9778 5.75095C20.6878 7.46098 21.1775 9.7574 20.0736 10.8796L18.7491 11.9329H18.7498Z"
              fill="#EFECF2"
            />
            <path
              d="M14.9233 9.80612C13.3694 8.25221 12.824 6.21453 13.5651 5.01318L12.7962 5.97998C11.6014 7.47012 11.8792 9.69617 13.4559 11.2728C15.0325 12.8494 17.2593 13.1272 18.7502 11.9325L19.7155 11.1643C18.5141 11.9054 16.4765 11.36 14.9225 9.80612H14.9233Z"
              fill="#EFECF2"
            />
            <mask
              id="mask0_54_162170"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="12"
              y="5"
              width="8"
              height="8"
            >
              <path
                d="M14.9316 9.80819C13.3777 8.25428 12.8323 6.21661 13.5734 5.01526L12.8045 5.98205C11.6097 7.4722 11.8875 9.69825 13.4642 11.2749C15.0408 12.8515 17.2676 13.1293 18.7585 11.9346L19.7238 11.1664C18.5224 11.9074 16.4848 11.3621 14.9309 9.80819H14.9316Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_54_162170)">
              <path
                d="M17.1086 7.63372L11.835 12.9073L15.3993 16.4716L20.6729 11.198L17.1086 7.63372Z"
                fill="#B0A4BC"
              />
            </g>
            <path
              d="M8.40057 11.2944C9.05233 10.5388 9.09214 9.50491 8.4895 8.98509C7.88685 8.46527 6.86996 8.65641 6.2182 9.41201C5.56644 10.1676 5.52663 11.2015 6.12927 11.7214C6.73191 12.2412 7.74881 12.0501 8.40057 11.2944Z"
              fill="white"
            />
            <path
              d="M21.6428 7.59368C22.375 6.86144 21.9616 5.25915 20.7178 4.01602C19.4746 2.7729 17.8723 2.35876 17.1401 3.09101L15.5407 5.06418C14.8517 5.90784 15.068 7.38552 16.2078 8.5253C17.3475 9.66507 18.8259 9.8813 19.6689 9.1923L21.642 7.59295L21.6428 7.59368Z"
              fill="#B16C3C"
            />
            <path
              d="M18.4975 9.87688C17.6685 9.87688 16.7471 9.47961 16.0002 8.73344C14.7967 7.52989 14.5013 5.87336 15.3134 4.87944L16.9326 2.88428C17.7924 2.0245 19.5464 2.43057 20.9251 3.8093C22.3038 5.18803 22.7099 6.94131 21.8501 7.80182L21.8274 7.82235L19.8542 9.4217C19.4775 9.72955 19.0047 9.87761 18.4982 9.87761L18.4975 9.87688ZM17.357 3.28889L15.7679 5.2496C15.1471 6.01043 15.4249 7.32979 16.4144 8.3193C17.4039 9.30882 18.7232 9.58735 19.4826 8.96652L21.4441 7.3767C22.0363 6.76393 21.6112 5.32583 20.5095 4.22343C19.4078 3.12177 17.969 2.69664 17.3562 3.28889H17.357Z"
              fill="#231815"
            />
            <path
              d="M21.5018 7.2933C20.9389 7.85623 19.5323 7.40252 18.4313 6.30085C17.3304 5.19919 16.876 3.79407 17.4389 3.23041C18.0018 2.66749 19.4084 3.1212 20.5093 4.22286C21.6103 5.3238 22.0647 6.72964 21.5018 7.2933Z"
              fill="#DFB47E"
            />
          </g>
          <defs>
            <clipPath id="clip0_54_162170">
              <rect width="20" height="20" fill="white" transform="translate(2.2998 2.43408)" />
            </clipPath>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.NEWBIE_4 && (
        <svg width={size} height={size} viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_dd_54_162107)">
            <path
              d="M19.7878 6.16881C17.9545 4.33524 15.468 3.84917 14.2329 5.0845L13.9433 5.44887C11.094 4.79125 7.97938 5.57204 5.75903 7.79271C2.33358 11.2187 2.33358 16.7744 5.75903 20.2003C9.18448 23.6263 14.7394 23.6263 18.1648 20.2003C20.3852 17.9797 21.1659 14.8653 20.5083 12.0149L20.8726 11.7253C22.1071 10.4907 21.6211 8.00312 19.7878 6.16955V6.16881Z"
              fill="#EFECF2"
            />
            <path
              d="M11.9624 23.0581C9.64085 23.0581 7.31934 22.1747 5.55201 20.4071C3.83965 18.6945 2.89697 16.4174 2.89697 13.9958C2.89697 11.5743 3.83965 9.29712 5.55201 7.58451C7.73277 5.40343 10.8144 4.48994 13.8279 5.12264L14.0258 4.87704C15.3724 3.53026 18.0502 4.01707 19.9949 5.96135C21.9396 7.90636 22.4264 10.5852 21.0798 11.932L21.0549 11.954L20.8342 12.13C21.4668 15.1439 20.5535 18.2253 18.3727 20.4071C16.6054 22.1747 14.2839 23.0581 11.9624 23.0581ZM11.944 5.51267C9.72368 5.51267 7.58177 6.38437 5.9669 7.99947C4.36523 9.60138 3.4834 11.7304 3.4834 13.9958C3.4834 16.2612 4.36523 18.3902 5.9669 19.9921C9.27287 23.2986 14.6518 23.2986 17.9578 19.9921C20.0389 17.9108 20.8855 14.9533 20.2229 12.0801L20.1811 11.8998L20.6766 11.5053C21.1941 10.9789 21.3774 10.1703 21.1927 9.22674C20.9984 8.23407 20.4259 7.22161 19.58 6.37557C17.8698 4.66516 15.574 4.17616 14.4517 5.27953L14.0574 5.77513L13.877 5.73334C13.2334 5.58451 12.5847 5.51193 11.9433 5.51193L11.944 5.51267Z"
              fill="#231815"
            />
            <path
              d="M11.9647 21.5007C16.1087 21.5007 19.468 18.1409 19.468 13.9963C19.468 9.85178 16.1087 6.49194 11.9647 6.49194C7.82077 6.49194 4.46143 9.85178 4.46143 13.9963C4.46143 18.1409 7.82077 21.5007 11.9647 21.5007Z"
              fill="#1053BF"
            />
            <mask
              id="mask0_54_162107"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="4"
              y="6"
              width="16"
              height="16"
            >
              <path
                d="M11.9608 21.5018C16.1048 21.5018 19.4641 18.142 19.4641 13.9974C19.4641 9.85288 16.1048 6.49304 11.9608 6.49304C7.81686 6.49304 4.45752 9.85288 4.45752 13.9974C4.45752 18.142 7.81686 21.5018 11.9608 21.5018Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_54_162107)">
              <path
                d="M9.14914 20.8645C13.6749 20.8645 17.3437 17.1952 17.3437 12.6688C17.3437 8.14238 13.6749 4.47302 9.14914 4.47302C4.62341 4.47302 0.95459 8.14238 0.95459 12.6688C0.95459 17.1952 4.62341 20.8645 9.14914 20.8645Z"
                fill="#3D81FA"
              />
            </g>
            <path
              d="M19.3578 12.5596C17.8668 13.7554 15.6398 13.4775 14.0631 11.8998C12.4863 10.3228 12.2092 8.09626 13.4033 6.60579L14.4574 5.28028C15.5797 4.1769 17.8756 4.66591 19.5857 6.37632C21.2959 8.08673 21.7855 10.3836 20.6816 11.5061L19.357 12.5596H19.3578Z"
              fill="#EFECF2"
            />
            <path
              d="M15.5309 10.4325C13.9769 8.87829 13.4315 6.84016 14.1726 5.63855L13.4037 6.60556C12.2088 8.09603 12.4866 10.3226 14.0634 11.8995C15.6401 13.4765 17.8671 13.7544 19.3581 12.5594L20.3235 11.791C19.122 12.5322 17.0842 11.9868 15.5302 10.4325H15.5309Z"
              fill="#EFECF2"
            />
            <mask
              id="mask1_54_162107"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="12"
              y="5"
              width="9"
              height="9"
            >
              <path
                d="M15.5304 10.4347C13.9764 8.88048 13.431 6.84236 14.1721 5.64075L13.4032 6.60776C12.2083 8.09822 12.4862 10.3248 14.0629 11.9017C15.6396 13.4787 17.8666 13.7566 19.3576 12.5616L20.323 11.7932C19.1215 12.5344 17.0837 11.989 15.5297 10.4347H15.5304Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask1_54_162107)">
              <path
                d="M17.7047 8.25902L12.4307 13.5338L15.9952 17.0989L21.2692 11.8241L17.7047 8.25902Z"
                fill="#B0A4BC"
              />
            </g>
            <path
              d="M22.2482 8.21975C22.9805 7.48735 22.5671 5.88471 21.3232 4.64131C20.0799 3.3979 18.4775 2.98368 17.7452 3.71609L16.1458 5.68969C15.4567 6.53354 15.673 8.01154 16.8128 9.15157C17.9527 10.2916 19.4312 10.5079 20.2742 9.81873L22.2475 8.21902L22.2482 8.21975Z"
              fill="#B16C3C"
            />
            <path
              d="M19.1018 10.5035C18.2727 10.5035 17.3513 10.1062 16.6043 9.35982C15.4007 8.15601 15.1053 6.49912 15.9175 5.50498L17.5367 3.50938C18.3966 2.64941 20.1507 3.05557 21.5296 4.4346C22.1673 5.07243 22.6218 5.8239 22.8094 6.5497C23.011 7.3305 22.8849 7.99765 22.4539 8.428L22.4312 8.44853L20.4579 10.0482C20.0811 10.3562 19.6083 10.5043 19.1018 10.5043V10.5035ZM17.9612 3.91407L16.372 5.87522C15.7511 6.63621 16.0289 7.95586 17.0185 8.9456C18.0081 9.93534 19.3275 10.2139 20.0877 9.59296L22.0493 8.00278C22.319 7.72346 22.3872 7.26012 22.2413 6.6956C22.0793 6.0695 21.6791 5.41407 21.1147 4.84882C20.0129 3.74692 18.574 3.3217 17.9612 3.91407Z"
              fill="#231815"
            />
            <path
              d="M22.1051 7.91925C21.5422 8.4823 20.1355 8.02849 19.0345 6.92658C17.9335 5.82468 17.479 4.41925 18.0419 3.85547C18.6049 3.29242 20.0116 3.74623 21.1126 4.84814C22.2136 5.94931 22.6681 7.35547 22.1051 7.91925Z"
              fill="#DFB47E"
            />
            <path
              d="M9.00433 11.9218C9.65613 11.166 9.69595 10.1318 9.09327 9.61189C8.49058 9.09196 7.47361 9.28314 6.8218 10.0389C6.17 10.7947 6.13018 11.8288 6.73286 12.3488C7.33555 12.8687 8.35252 12.6775 9.00433 11.9218Z"
              fill="white"
            />
          </g>
          <defs>
            <filter
              id="filter0_dd_54_162107"
              x="0.896973"
              y="0.434082"
              width="24.0063"
              height="24.624"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.370833 0 0 0 0 0.548779 0 0 0 0 1 0 0 0 1 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_54_162107" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.895 0 0 0 0 0.875 0 0 0 0 1 0 0 0 0.3 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_54_162107" result="effect2_dropShadow_54_162107" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_54_162107" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.NEWBIE_3 && (
        <svg width={size} height={size} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_54_162125)">
            <g filter="url(#filter0_dd_54_162125)">
              <path
                d="M11.7639 22.5336C9.3423 22.5336 7.06517 21.591 5.35256 19.8788C1.81737 16.3444 1.81737 10.5934 5.35256 7.05903C7.53438 4.8777 10.6158 3.96514 13.6297 4.5977L13.8276 4.35215C14.4963 3.68368 15.4963 3.4396 16.6444 3.66315C17.7499 3.87865 18.8702 4.50901 19.7976 5.43622C20.725 6.36344 21.3555 7.48343 21.571 8.58949C21.7954 9.73733 21.5505 10.7378 20.8826 11.4056L20.8577 11.4276L20.6363 11.6035C21.269 14.6168 20.3555 17.6975 18.1744 19.8788C16.4618 21.591 14.1854 22.5336 11.7631 22.5336H11.7639ZM11.7455 4.98764C9.52485 4.98764 7.38262 5.85915 5.76752 7.4739C2.46107 10.7796 2.46107 16.1582 5.76752 19.4639C7.36943 21.0655 9.49919 21.9473 11.7639 21.9473C14.0285 21.9473 16.1583 21.0655 17.7602 19.4639C19.8416 17.383 20.6883 14.4262 20.0256 11.5536L19.9838 11.3733L20.4794 10.979C20.997 10.4527 21.1803 9.64424 20.9955 8.7009C20.8012 7.70845 20.2287 6.69621 19.3826 5.85035C18.5366 5.0045 17.5241 4.43205 16.5315 4.23854C15.5879 4.05456 14.7793 4.23781 14.2529 4.75529L13.8584 5.25078L13.6781 5.209C13.0344 5.06021 12.3856 4.98764 11.7441 4.98764H11.7455Z"
                fill="#040000"
              />
              <path
                d="M18.9001 9.97747C18.071 9.97747 17.1494 9.58019 16.4023 8.83402C15.1985 7.63048 14.9031 5.97395 15.7154 4.98003L17.3349 2.98487C18.1949 2.12509 19.9493 2.53116 21.3283 3.90989C22.7073 5.28861 23.1135 7.04189 22.2535 7.90241L22.2308 7.92293L20.2572 9.52229C19.8804 9.83014 19.4075 9.9782 18.9009 9.9782L18.9001 9.97747ZM17.7601 3.38947L16.1707 5.35018C15.5497 6.11101 15.8276 7.43037 16.8173 8.41989C17.807 9.40941 19.1267 9.68794 19.887 9.06711L21.8488 7.47728C22.4412 6.86451 22.016 5.42641 20.9141 4.32475C20.3488 3.75962 19.6934 3.35942 19.0673 3.19816C18.5028 3.0523 18.0394 3.12047 17.7601 3.3902V3.38947Z"
                fill="#040000"
              />
              <path
                d="M19.5927 5.54211C17.7595 3.7084 15.2733 3.22229 14.0382 4.45772L13.7487 4.82212C10.8996 4.16445 7.78518 4.94529 5.56499 7.16613C2.13979 10.5923 2.13979 16.1485 5.56499 19.5747C8.99019 23.0009 14.5447 23.0009 17.9699 19.5747C20.1901 17.3538 20.9707 14.2392 20.3132 11.3886L20.6775 11.099C21.9118 9.86428 21.4259 7.37656 19.5927 5.54285V5.54211Z"
                fill="#EFECF2"
              />
              <path
                d="M11.7678 22.4327C9.44651 22.4327 7.12517 21.5492 5.35797 19.7815C3.64573 18.0687 2.70312 15.7914 2.70312 13.3697C2.70312 10.948 3.64573 8.67067 5.35797 6.95794C7.53857 4.77669 10.62 3.86314 13.6333 4.49588L13.8312 4.25026C15.1777 2.90339 17.8552 3.39023 19.7998 5.33465C20.727 6.26214 21.3574 7.38245 21.5729 8.48884C21.7972 9.63702 21.5524 10.6378 20.8846 11.3058L20.8597 11.3278L20.6383 11.5037C21.2709 14.5179 20.3576 17.5995 18.177 19.7815C16.4098 21.5492 14.0885 22.4327 11.7671 22.4327H11.7678ZM11.7495 4.88594C9.52934 4.88594 7.38758 5.7577 5.77283 7.37292C4.17128 8.97495 3.28951 11.1041 3.28951 13.3697C3.28951 15.6353 4.17128 17.7644 5.77283 19.3665C9.07856 22.6732 14.4571 22.6732 17.7629 19.3665C19.8438 17.2849 20.6904 14.3272 20.0278 11.4539L19.986 11.2735L20.4815 10.879C20.999 10.3526 21.1822 9.5439 20.9975 8.60029C20.8032 7.60754 20.2308 6.59501 19.3849 5.7489C17.6749 4.03837 15.3792 3.54933 14.257 4.65278L13.8627 5.14842L13.6824 5.10663C13.0388 4.95779 12.3901 4.8852 11.7488 4.8852L11.7495 4.88594Z"
                fill="#231815"
              />
              <path
                d="M11.7698 20.8751C15.9135 20.8751 19.2726 17.515 19.2726 13.3702C19.2726 9.22531 15.9135 5.86523 11.7698 5.86523C7.62618 5.86523 4.26709 9.22531 4.26709 13.3702C4.26709 17.515 7.62618 20.8751 11.7698 20.8751Z"
                fill="#E1E4E5"
              />
              <mask
                id="mask0_54_162125"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="2"
                y="9"
                width="19"
                height="14"
              >
                <path d="M20.5377 9.85559H2.99463V22.1336H20.5377V9.85559Z" fill="white" />
              </mask>
              <g mask="url(#mask0_54_162125)">
                <path
                  d="M11.7625 20.8754C15.9062 20.8754 19.2653 17.5153 19.2653 13.3704C19.2653 9.22556 15.9062 5.86548 11.7625 5.86548C7.61886 5.86548 4.25977 9.22556 4.25977 13.3704C4.25977 17.5153 7.61886 20.8754 11.7625 20.8754Z"
                  fill="#1053BF"
                />
              </g>
              <mask
                id="mask1_54_162125"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="2"
                y="9"
                width="19"
                height="14"
              >
                <path d="M20.5377 9.85559H2.99463V22.1336H20.5377V9.85559Z" fill="white" />
              </mask>
              <g mask="url(#mask1_54_162125)">
                <mask
                  id="mask2_54_162125"
                  style={{ maskType: 'luminance' }}
                  maskUnits="userSpaceOnUse"
                  x="4"
                  y="5"
                  width="16"
                  height="16"
                >
                  <path
                    d="M11.7508 20.8753C15.8945 20.8753 19.2535 17.5152 19.2535 13.3703C19.2535 9.22544 15.8945 5.86536 11.7508 5.86536C7.60714 5.86536 4.24805 9.22544 4.24805 13.3703C4.24805 17.5152 7.60714 20.8753 11.7508 20.8753Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask2_54_162125)">
                  <path
                    d="M8.93906 20.238C13.4645 20.238 17.133 16.5684 17.133 12.0417C17.133 7.51497 13.4645 3.84534 8.93906 3.84534C4.41367 3.84534 0.745117 7.51497 0.745117 12.0417C0.745117 16.5684 4.41367 20.238 8.93906 20.238Z"
                    fill="#3D81FA"
                  />
                </g>
              </g>
              <mask
                id="mask3_54_162125"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="5"
                width="16"
                height="16"
              >
                <path
                  d="M11.7669 20.875C15.9106 20.875 19.2697 17.5149 19.2697 13.3701C19.2697 9.22519 15.9106 5.86511 11.7669 5.86511C7.62326 5.86511 4.26416 9.22519 4.26416 13.3701C4.26416 17.5149 7.62326 20.875 11.7669 20.875Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask3_54_162125)">
                <path
                  d="M11.7633 10.3202C15.5908 10.3202 18.6936 10.1127 18.6936 9.85681C18.6936 9.60089 15.5908 9.39343 11.7633 9.39343C7.93581 9.39343 4.83301 9.60089 4.83301 9.85681C4.83301 10.1127 7.93581 10.3202 11.7633 10.3202Z"
                  fill="#70A0F4"
                />
              </g>
              <path
                d="M19.1546 11.9344C17.6638 13.1303 15.437 12.8524 13.8603 11.2746C12.2837 9.69748 12.0066 7.47078 13.2007 5.9802L14.2547 4.65459C15.3769 3.55113 17.6725 4.04017 19.3826 5.75071C21.0926 7.46124 21.5822 9.75833 20.4784 10.8808L19.1539 11.9344H19.1546Z"
                fill="#EFECF2"
              />
              <path
                d="M15.3281 9.80716C13.7742 8.25279 13.2288 6.21452 13.9699 5.01282L13.201 5.9799C12.0062 7.47048 12.284 9.69718 13.8606 11.2743C15.4373 12.8514 17.6641 13.1292 19.1549 11.9341L20.1203 11.1658C18.9189 11.907 16.8812 11.3615 15.3273 9.80716H15.3281Z"
                fill="#EFECF2"
              />
              <mask
                id="mask4_54_162125"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="12"
                y="5"
                width="9"
                height="8"
              >
                <path
                  d="M15.329 9.80606C13.7751 8.25169 13.2298 6.21342 13.9708 5.01172L13.2019 5.9788C12.0072 7.46938 12.285 9.69608 13.8616 11.2732C15.4383 12.8503 17.665 13.1281 19.1559 11.933L20.1212 11.1647C18.9199 11.9059 16.8822 11.3604 15.3283 9.80606H15.329Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask4_54_162125)">
                <path
                  d="M17.5026 7.63278L12.229 12.908L15.7933 16.4733L21.0669 11.1981L17.5026 7.63278Z"
                  fill="#B0A4BC"
                />
              </g>
              <path
                d="M8.80535 11.2961C9.45711 10.5402 9.49693 9.506 8.89428 8.98603C8.29164 8.46605 7.27475 8.65725 6.62299 9.41307C5.97123 10.1689 5.93141 11.2031 6.53405 11.7231C7.1367 12.2431 8.15359 12.0519 8.80535 11.2961Z"
                fill="white"
              />
              <path
                d="M22.0456 7.59438C22.7779 6.86192 22.3645 5.25916 21.1206 4.01567C19.8775 2.77218 18.2752 2.35792 17.5429 3.09038L15.9436 5.06413C15.2546 5.90804 15.4708 7.38615 16.6106 8.52626C17.7504 9.66638 19.2288 9.88267 20.0717 9.19347L22.0449 7.59364L22.0456 7.59438Z"
                fill="#B16C3C"
              />
              <path
                d="M18.8993 9.8773C18.0704 9.8773 17.149 9.47991 16.4021 8.73352C15.1985 7.52962 14.9032 5.87261 15.7153 4.8784L17.3344 2.88265C17.7654 2.45154 18.4324 2.32543 19.2123 2.52705C19.938 2.71475 20.6885 3.16933 21.327 3.80721C22.7057 5.18634 23.1118 6.94014 22.252 7.8009L22.2293 7.82143L20.2561 9.42126C19.8793 9.7292 19.4066 9.8773 18.9001 9.8773H18.8993ZM17.7588 3.28664L16.1697 5.24793C15.5489 6.00898 15.8267 7.32873 16.8162 8.31854C17.8057 9.30834 19.1251 9.58696 19.8845 8.96594L21.8459 7.37565C22.4382 6.76344 22.013 5.32418 20.9114 4.22146C20.3462 3.65617 19.691 3.25585 19.065 3.09455C18.5006 2.94864 18.0374 3.01683 17.7581 3.28664H17.7588Z"
                fill="#231815"
              />
              <path
                d="M21.9061 7.29286C21.3432 7.85595 19.9366 7.4021 18.8356 6.30012C17.7347 5.19813 17.2803 3.7926 17.8432 3.22878C18.4061 2.66568 19.8127 3.11953 20.9136 4.22152C22.0146 5.32277 22.469 6.72903 21.9061 7.29286Z"
                fill="#DFB47E"
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_dd_54_162125"
              x="0.700195"
              y="0.43335"
              width="24.0034"
              height="24.1003"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.370833 0 0 0 0 0.548779 0 0 0 0 1 0 0 0 0.5 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_54_162125" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.895 0 0 0 0 0.875 0 0 0 0 1 0 0 0 0.15 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_54_162125" result="effect2_dropShadow_54_162125" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_54_162125" result="shape" />
            </filter>
            <clipPath id="clip0_54_162125">
              <rect width="24" height="24" fill="white" transform="translate(0.700195 0.434082)" />
            </clipPath>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.NEWBIE_2 && (
        <svg width={size} height={size} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_54_162143)">
            <g filter="url(#filter0_dd_54_162143)">
              <path
                d="M11.5637 22.5336C9.14211 22.5336 6.86498 21.591 5.15237 19.8788C1.61718 16.3444 1.61718 10.5934 5.15237 7.05903C7.33419 4.8777 10.4156 3.96514 13.4295 4.5977L13.6274 4.35215C14.2961 3.68368 15.2961 3.4396 16.4442 3.66315C17.5497 3.87865 18.67 4.50901 19.5974 5.43622C20.5248 6.36344 21.1553 7.48343 21.3708 8.58949C21.5952 9.73733 21.3503 10.7378 20.6824 11.4056L20.6575 11.4276L20.4361 11.6035C21.0688 14.6168 20.1553 17.6975 17.9742 19.8788C16.2616 21.591 13.9852 22.5336 11.5629 22.5336H11.5637ZM11.5453 4.98764C9.32466 4.98764 7.18243 5.85915 5.56733 7.4739C2.26087 10.7796 2.26087 16.1582 5.56733 19.4639C7.16923 21.0655 9.299 21.9473 11.5637 21.9473C13.8283 21.9473 15.9581 21.0655 17.56 19.4639C19.6414 17.383 20.4881 14.4262 19.8254 11.5536L19.7836 11.3733L20.2792 10.979C20.7968 10.4527 20.9801 9.64424 20.7953 8.7009C20.601 7.70845 20.0285 6.69621 19.1824 5.85035C18.3364 5.0045 17.3239 4.43205 16.3313 4.23854C15.3877 4.05456 14.5791 4.23781 14.0527 4.75529L13.6582 5.25078L13.4779 5.209C12.8342 5.06021 12.1854 4.98764 11.5439 4.98764H11.5453Z"
                fill="#040000"
              />
              <path
                d="M18.7 9.97747C17.8708 9.97747 16.9492 9.58019 16.2022 8.83402C14.9983 7.63048 14.7029 5.97395 15.5152 4.98003L17.1347 2.98487C17.9947 2.12509 19.7491 2.53116 21.1281 3.90989C22.5071 5.28861 22.9133 7.04189 22.0533 7.90241L22.0306 7.92293L20.057 9.52229C19.6802 9.83014 19.2073 9.9782 18.7007 9.9782L18.7 9.97747ZM17.5599 3.38947L15.9705 5.35018C15.3495 6.11101 15.6274 7.43037 16.6171 8.41989C17.6068 9.40941 18.9265 9.68794 19.6868 9.06711L21.6486 7.47728C22.241 6.86451 21.8158 5.42641 20.7139 4.32475C20.1486 3.75962 19.4932 3.35942 18.8671 3.19816C18.3026 3.0523 17.8392 3.12047 17.5599 3.3902V3.38947Z"
                fill="#040000"
              />
              <path
                d="M19.3923 5.54428C17.5587 3.7111 15.0719 3.22514 13.8365 4.46021L13.5469 4.8245C10.6972 4.16702 7.58213 4.94764 5.36146 7.16782C1.9355 10.593 1.9355 16.1475 5.36146 19.5727C8.78741 22.9979 14.3431 22.9979 17.7691 19.5727C19.9898 17.3525 20.7705 14.2388 20.1129 11.389L20.4773 11.0995C21.7119 9.86518 21.2258 7.37819 19.3923 5.54501V5.54428Z"
                fill="#EFECF2"
              />
              <path
                d="M11.5656 22.4333C9.14406 22.4333 6.86693 21.4907 5.15432 19.7785C1.61913 16.244 1.61913 10.4931 5.15432 6.95869C7.33541 4.77735 10.4175 3.8648 13.4314 4.49736L13.6294 4.25181C14.298 3.58333 15.298 3.33925 16.4461 3.56281C17.5517 3.77831 18.6719 4.40867 19.5993 5.33588C20.5268 6.2631 21.1573 7.38309 21.3728 8.48915C21.5971 9.63699 21.3523 10.6375 20.6844 11.3052L20.6595 11.3272L20.438 11.5031C21.0707 14.5164 20.1573 17.5971 17.9762 19.7785C16.2636 21.4907 13.9872 22.4333 11.5649 22.4333H11.5656ZM11.5473 4.8873C9.32661 4.8873 7.18438 5.75881 5.56928 7.37356C2.26283 10.6793 2.26283 16.0579 5.56928 19.3636C7.17119 20.9651 9.30095 21.8469 11.5656 21.8469C13.8303 21.8469 15.96 20.9651 17.5619 19.3636C19.6433 17.2827 20.4901 14.3258 19.8273 11.4533L19.7856 11.273L20.2812 10.8787C20.7988 10.3524 20.982 9.5439 20.7973 8.60056C20.603 7.60811 20.0304 6.59587 19.1844 5.75001C18.3383 4.90416 17.3259 4.3317 16.3332 4.13746C15.3897 3.95349 14.581 4.13673 14.0554 4.65421L13.6609 5.14971L13.4806 5.10793C12.8369 4.95913 12.188 4.88657 11.5466 4.88657L11.5473 4.8873Z"
                fill="#231815"
              />
              <path
                d="M11.563 20.8717C15.7076 20.8717 19.0674 17.5126 19.0674 13.369C19.0674 9.22531 15.7076 5.86621 11.563 5.86621C7.41843 5.86621 4.05859 9.22531 4.05859 13.369C4.05859 17.5126 7.41843 20.8717 11.563 20.8717Z"
                fill="#E1E4E5"
              />
              <mask
                id="mask0_54_162143"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="2"
                y="14"
                width="19"
                height="9"
              >
                <path d="M20.3326 14.0372H2.78564V22.1381H20.3326V14.0372Z" fill="white" />
              </mask>
              <g mask="url(#mask0_54_162143)">
                <path
                  d="M11.5596 20.8704C15.7041 20.8704 19.064 17.5113 19.064 13.3676C19.064 9.22396 15.7041 5.86487 11.5596 5.86487C7.41501 5.86487 4.05518 9.22396 4.05518 13.3676C4.05518 17.5113 7.41501 20.8704 11.5596 20.8704Z"
                  fill="#1053BF"
                />
              </g>
              <mask
                id="mask1_54_162143"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="2"
                y="14"
                width="19"
                height="9"
              >
                <path d="M20.3326 14.0372H2.78564V22.1286H20.3326V14.0372Z" fill="white" />
              </mask>
              <g mask="url(#mask1_54_162143)">
                <mask
                  id="mask2_54_162143"
                  style={{ maskType: 'luminance' }}
                  maskUnits="userSpaceOnUse"
                  x="4"
                  y="5"
                  width="16"
                  height="16"
                >
                  <path
                    d="M11.5654 20.8713C15.71 20.8713 19.0698 17.5122 19.0698 13.3686C19.0698 9.22494 15.71 5.86584 11.5654 5.86584C7.42087 5.86584 4.06104 9.22494 4.06104 13.3686C4.06104 17.5122 7.42087 20.8713 11.5654 20.8713Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask2_54_162143)">
                  <path
                    d="M8.74555 20.2348C13.2719 20.2348 16.9413 16.5663 16.9413 12.0409C16.9413 7.51548 13.2719 3.84692 8.74555 3.84692C4.21917 3.84692 0.549805 7.51548 0.549805 12.0409C0.549805 16.5663 4.21917 20.2348 8.74555 20.2348Z"
                    fill="#3D81FA"
                  />
                </g>
              </g>
              <mask
                id="mask3_54_162143"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="5"
                width="16"
                height="16"
              >
                <path
                  d="M11.5684 20.8706C15.7129 20.8706 19.0728 17.5115 19.0728 13.3679C19.0728 9.22421 15.7129 5.86511 11.5684 5.86511C7.4238 5.86511 4.06396 9.22421 4.06396 13.3679C4.06396 17.5115 7.4238 20.8706 11.5684 20.8706Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask3_54_162143)">
                <path
                  d="M11.5677 14.5012C15.8807 14.5012 19.3771 14.2938 19.3771 14.0379C19.3771 13.7821 15.8807 13.5747 11.5677 13.5747C7.25468 13.5747 3.7583 13.7821 3.7583 14.0379C3.7583 14.2938 7.25468 14.5012 11.5677 14.5012Z"
                  fill="#70A0F4"
                />
              </g>
              <path
                d="M18.9559 11.9321C17.4647 13.1276 15.2374 12.8498 13.6604 11.2725C12.0835 9.69583 11.8063 7.46978 13.0006 5.97964L14.0549 4.65441C15.1773 3.55128 17.4735 4.04018 19.1839 5.75021C20.8943 7.46025 21.3841 9.75667 20.28 10.8789L18.9552 11.9321H18.9559Z"
                fill="#EFECF2"
              />
              <path
                d="M15.1285 9.80575C13.5743 8.25184 13.0288 6.21417 13.77 5.01282L13.0009 5.97961C11.8059 7.46975 12.0838 9.6958 13.6608 11.2724C15.2377 12.8491 17.465 13.1269 18.9562 11.9321L19.9218 11.164C18.7201 11.905 16.682 11.3597 15.1278 9.80575H15.1285Z"
                fill="#EFECF2"
              />
              <mask
                id="mask4_54_162143"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="12"
                y="5"
                width="8"
                height="8"
              >
                <path
                  d="M15.1251 9.80465C13.5708 8.25074 13.0254 6.21307 13.7666 5.01172L12.9975 5.97851C11.8025 7.46866 12.0804 9.69471 13.6573 11.2713C15.2343 12.848 17.4616 13.1258 18.9528 11.931L19.9183 11.1629C18.7167 11.9039 16.6786 11.3586 15.1244 9.80465H15.1251Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask4_54_162143)">
                <path
                  d="M17.3036 7.63128L12.0288 12.9049L15.5939 16.4692L20.8687 11.1956L17.3036 7.63128Z"
                  fill="#B0A4BC"
                />
              </g>
              <path
                d="M8.6059 11.2938C9.2578 10.5382 9.29762 9.5043 8.69485 8.98448C8.09207 8.46466 7.07495 8.6558 6.42305 9.4114C5.77115 10.167 5.73132 11.2009 6.3341 11.7208C6.93687 12.2406 7.95399 12.0494 8.6059 11.2938Z"
                fill="white"
              />
              <path
                d="M21.8468 7.59295C22.5792 6.86071 22.1658 5.25842 20.9216 4.01529C19.6782 2.77216 18.0756 2.35803 17.3432 3.09027L15.7435 5.06345C15.0543 5.9071 15.2706 7.38478 16.4106 8.52456C17.5507 9.66434 19.0294 9.88057 19.8725 9.19157L21.8461 7.59222L21.8468 7.59295Z"
                fill="#B16C3C"
              />
              <path
                d="M18.7 9.87615C17.8708 9.87615 16.9492 9.47887 16.2022 8.7327C14.9983 7.52916 14.7029 5.87263 15.5152 4.87871L17.1347 2.88355C17.9947 2.02377 19.7491 2.42984 21.1281 3.80857C22.5071 5.1873 22.9133 6.94058 22.0533 7.80109L22.0306 7.82161L20.057 9.42097C19.6802 9.72882 19.2073 9.87688 18.7007 9.87688L18.7 9.87615ZM17.5599 3.28815L15.9705 5.24887C15.3495 6.0097 15.6274 7.32905 16.6171 8.31857C17.6068 9.30809 18.9265 9.58662 19.686 8.96579L21.6479 7.37596C22.2403 6.7632 21.8151 5.3251 20.7132 4.22343C20.1479 3.65831 19.4925 3.2581 18.8664 3.09685C18.3019 2.95098 17.8385 3.01915 17.5592 3.28889L17.5599 3.28815Z"
                fill="#231815"
              />
              <path
                d="M21.7068 7.29257C21.1438 7.8555 19.7369 7.40178 18.6357 6.30012C17.5345 5.19846 17.08 3.79334 17.6431 3.22968C18.2061 2.66676 19.613 3.12047 20.7142 4.22213C21.8153 5.32306 22.2699 6.72891 21.7068 7.29257Z"
                fill="#DFB47E"
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_dd_54_162143"
              x="0.5"
              y="0.43335"
              width="24.0034"
              height="24.1003"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.305924 0 0 0 0 0.501133 0 0 0 0 1 0 0 0 0.5 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_54_162143" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="0.75" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_54_162143" result="effect2_dropShadow_54_162143" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_54_162143" result="shape" />
            </filter>
            <clipPath id="clip0_54_162143">
              <rect width="24" height="24" fill="white" transform="translate(0.5 0.434082)" />
            </clipPath>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.NEWBIE_1 && (
        <svg width={size} height={size} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_54_162161)">
            <g filter="url(#filter0_dd_54_162161)">
              <path
                d="M11.9553 22.5336C9.53371 22.5336 7.25658 21.591 5.54397 19.8788C2.00878 16.3444 2.00878 10.5934 5.54397 7.05903C7.72579 4.8777 10.8072 3.96514 13.8211 4.5977L14.019 4.35215C14.6877 3.68368 15.6877 3.4396 16.8358 3.66315C17.9413 3.87865 19.0616 4.50901 19.989 5.43622C20.9164 6.36344 21.5469 7.48343 21.7624 8.58949C21.9868 9.73733 21.7419 10.7378 21.074 11.4056L21.0491 11.4276L20.8277 11.6035C21.4604 14.6168 20.5469 17.6975 18.3658 19.8788C16.6532 21.591 14.3768 22.5336 11.9545 22.5336H11.9553ZM11.9369 4.98764C9.71626 4.98764 7.57403 5.85915 5.95893 7.4739C2.65248 10.7796 2.65248 16.1582 5.95893 19.4639C7.56083 21.0655 9.6906 21.9473 11.9553 21.9473C14.2199 21.9473 16.3497 21.0655 17.9516 19.4639C20.033 17.383 20.8797 14.4262 20.217 11.5536L20.1752 11.3733L20.6708 10.979C21.1884 10.4527 21.3717 9.64424 21.1869 8.7009C20.9927 7.70845 20.4201 6.69621 19.574 5.85035C18.728 5.0045 17.7155 4.43205 16.7229 4.23854C15.7793 4.05456 14.9707 4.23781 14.4443 4.75529L14.0498 5.25078L13.8695 5.209C13.2258 5.06021 12.577 4.98764 11.9355 4.98764H11.9369Z"
                fill="#040000"
              />
              <path
                d="M19.0916 9.97747C18.2624 9.97747 17.3408 9.58019 16.5938 8.83402C15.3899 7.63048 15.0945 5.97395 15.9068 4.98003L17.5263 2.98487C18.3863 2.12509 20.1407 2.53116 21.5197 3.90989C22.8987 5.28861 23.3049 7.04189 22.4449 7.90241L22.4222 7.92293L20.4486 9.52229C20.0718 9.83014 19.5989 9.9782 19.0923 9.9782L19.0916 9.97747ZM17.9515 3.38947L16.3621 5.35018C15.7411 6.11101 16.019 7.43037 17.0087 8.41989C17.9984 9.40941 19.3181 9.68794 20.0784 9.06711L22.0402 7.47728C22.6326 6.86451 22.2074 5.42641 21.1055 4.32475C20.5402 3.75962 19.8848 3.35942 19.2587 3.19816C18.6942 3.0523 18.2309 3.12047 17.9515 3.3902V3.38947Z"
                fill="#040000"
              />
              <path
                d="M19.7743 5.54172C17.9412 3.70841 15.4549 3.22242 14.2198 4.45757L13.9303 4.82189C11.0812 4.16436 7.96682 4.94504 5.74663 7.16539C2.32143 10.5908 2.32143 16.1457 5.74663 19.5712C9.17183 22.9966 14.7263 22.9966 18.1515 19.5712C20.3717 17.3508 21.1523 14.2369 20.4949 11.3869L20.8591 11.0974C22.0935 9.86294 21.6075 7.37577 19.7743 5.54246V5.54172Z"
                fill="#EFECF2"
              />
              <path
                d="M11.9495 22.4329C9.52847 22.4329 7.25184 21.4902 5.53961 19.7779C3.82737 18.0655 2.88477 15.7887 2.88477 13.3675C2.88477 10.9463 3.82737 8.66953 5.53961 6.95717C7.72021 4.77568 10.8016 3.86305 13.8149 4.49566L14.0128 4.25009C15.3593 2.90352 18.0369 3.39025 19.9814 5.33424C21.926 7.27897 22.4127 9.95747 21.0662 11.304L21.0413 11.326L20.82 11.502C21.4525 14.5154 20.5392 17.5964 18.3586 19.7779C16.6464 21.4902 14.3705 22.4329 11.9488 22.4329H11.9495ZM11.9312 4.88563C9.71098 4.88563 7.56922 5.7572 5.95447 7.37207C4.35292 8.97374 3.47115 11.1025 3.47115 13.3675C3.47115 15.6326 4.35292 17.7613 5.95447 19.363C7.55603 20.9646 9.68459 21.8465 11.9495 21.8465C14.2144 21.8465 16.3429 20.9646 17.9445 19.363C20.0254 17.2819 20.872 14.3249 20.2094 11.4521L20.1676 11.2718L20.6631 10.8774C21.1806 10.3511 21.3638 9.54257 21.1791 8.59916C20.9849 7.60664 20.4124 6.59432 19.5666 5.74841C17.8565 4.03825 15.5609 3.54932 14.4387 4.65253L14.0443 5.14806L13.864 5.10627C13.2205 4.95747 12.5718 4.8849 11.9304 4.8849L11.9312 4.88563Z"
                fill="#231815"
              />
              <path
                d="M11.952 20.8709C16.0956 20.8709 19.4547 17.5115 19.4547 13.3676C19.4547 9.2236 16.0956 5.86426 11.952 5.86426C7.80831 5.86426 4.44922 9.2236 4.44922 13.3676C4.44922 17.5115 7.80831 20.8709 11.952 20.8709Z"
                fill="#E1E4E5"
              />
              <mask
                id="mask0_54_162161"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="3"
                y="17"
                width="18"
                height="6"
              >
                <path d="M20.7188 17.2632H3.17578V22.1386H20.7188V17.2632Z" fill="white" />
              </mask>
              <g mask="url(#mask0_54_162161)">
                <path
                  d="M11.9476 20.8705C16.0912 20.8705 19.4503 17.5111 19.4503 13.3672C19.4503 9.22323 16.0912 5.86389 11.9476 5.86389C7.80392 5.86389 4.44482 9.22323 4.44482 13.3672C4.44482 17.5111 7.80392 20.8705 11.9476 20.8705Z"
                  fill="#1053BF"
                />
              </g>
              <mask
                id="mask1_54_162161"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="3"
                y="17"
                width="18"
                height="6"
              >
                <path d="M20.7188 17.2632H3.17578V22.1386H20.7188V17.2632Z" fill="white" />
              </mask>
              <g mask="url(#mask1_54_162161)">
                <mask
                  id="mask2_54_162161"
                  style={{ maskType: 'luminance' }}
                  maskUnits="userSpaceOnUse"
                  x="4"
                  y="5"
                  width="16"
                  height="16"
                >
                  <path
                    d="M11.9515 20.8679C16.0951 20.8679 19.4542 17.5086 19.4542 13.3646C19.4542 9.22067 16.0951 5.86133 11.9515 5.86133C7.80783 5.86133 4.44873 9.22067 4.44873 13.3646C4.44873 17.5086 7.80783 20.8679 11.9515 20.8679Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask2_54_162161)">
                  <path
                    d="M9.13584 20.2315C13.6612 20.2315 17.3298 16.5627 17.3298 12.037C17.3298 7.51123 13.6612 3.84241 9.13584 3.84241C4.61045 3.84241 0.941895 7.51123 0.941895 12.037C0.941895 16.5627 4.61045 20.2315 9.13584 20.2315Z"
                    fill="#3D81FA"
                  />
                </g>
              </g>
              <mask
                id="mask3_54_162161"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="4"
                y="5"
                width="16"
                height="16"
              >
                <path
                  d="M11.9481 20.8717C16.0917 20.8717 19.4508 17.5124 19.4508 13.3684C19.4508 9.22445 16.0917 5.86511 11.9481 5.86511C7.80441 5.86511 4.44531 9.22445 4.44531 13.3684C4.44531 17.5124 7.80441 20.8717 11.9481 20.8717Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask3_54_162161)">
                <path
                  d="M11.9511 17.727C15.658 17.727 18.663 17.5196 18.663 17.2638C18.663 17.0079 15.658 16.8005 11.9511 16.8005C8.24426 16.8005 5.23926 17.0079 5.23926 17.2638C5.23926 17.5196 8.24426 17.727 11.9511 17.727Z"
                  fill="#70A0F4"
                />
              </g>
              <path
                d="M19.3412 11.9317C17.8503 13.1273 15.6235 12.8495 14.0469 11.272C12.4702 9.69526 12.1932 7.46905 13.3872 5.9788L14.4412 4.65348C15.5634 3.55027 17.8591 4.0392 19.5691 5.74936C21.2791 7.45952 21.7688 9.7561 20.6649 10.8784L19.3404 11.9317H19.3412Z"
                fill="#EFECF2"
              />
              <path
                d="M15.5146 9.8061C13.9607 8.25208 13.4153 6.21425 14.1564 5.01282L13.3875 5.97968C12.1927 7.46993 12.4705 9.69615 14.0472 11.2729C15.6238 12.8496 17.8506 13.1275 19.3415 11.9326L20.3068 11.1644C19.1054 11.9055 17.0678 11.3601 15.5139 9.8061H15.5146Z"
                fill="#EFECF2"
              />
              <mask
                id="mask4_54_162161"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="12"
                y="5"
                width="9"
                height="8"
              >
                <path
                  d="M15.518 9.805C13.9641 8.25098 13.4188 6.21316 14.1598 5.01172L13.3909 5.97859C12.1962 7.46884 12.474 9.69505 14.0506 11.2718C15.6272 12.8485 17.854 13.1264 19.3449 11.9315L20.3102 11.1633C19.1089 11.9044 17.0712 11.359 15.5173 9.805H15.518Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask4_54_162161)">
                <path
                  d="M17.6921 7.63297L12.4185 12.907L15.9828 16.4715L21.2564 11.1975L17.6921 7.63297Z"
                  fill="#B0A4BC"
                />
              </g>
              <path
                d="M8.99176 11.2939C9.64349 10.5382 9.6833 9.50427 9.08067 8.98443C8.47805 8.46459 7.46119 8.65573 6.80946 9.41136C6.15773 10.167 6.11792 11.201 6.72054 11.7208C7.32317 12.2406 8.34002 12.0495 8.99176 11.2939Z"
                fill="white"
              />
              <path
                d="M22.2356 7.59331C22.9678 6.86101 22.5544 5.2586 21.3105 4.01539C20.0674 2.77217 18.4651 2.358 17.7329 3.0903L16.1335 5.06362C15.4445 5.90734 15.6608 7.38513 16.8005 8.52499C17.9403 9.66485 19.4187 9.88109 20.2616 9.19205L22.2348 7.59257L22.2356 7.59331Z"
                fill="#B16C3C"
              />
              <path
                d="M19.0893 9.87566C18.2603 9.87566 17.3389 9.47836 16.592 8.73214C15.3885 7.5285 15.0931 5.87185 15.9052 4.87786L17.5244 2.88255C17.9554 2.45153 18.6224 2.32545 19.4023 2.52703C20.1279 2.71469 20.8785 3.16917 21.5169 3.80691C22.8956 5.18574 23.3017 6.93914 22.4419 7.79972L22.4192 7.82025L20.446 9.41972C20.0693 9.72759 19.5965 9.87566 19.09 9.87566H19.0893ZM17.9488 3.28645L16.3597 5.24731C15.7389 6.0082 16.0167 7.32765 17.0062 8.31724C17.9957 9.30683 19.315 9.58538 20.0744 8.96451L22.0359 7.37456C22.6281 6.76248 22.203 5.32355 21.1013 4.22107C20.5362 3.6559 19.8809 3.25567 19.2549 3.0944C18.6906 2.94853 18.2273 3.0167 17.948 3.28645H17.9488Z"
                fill="#231815"
              />
              <path
                d="M22.0926 7.29191C21.5297 7.85488 20.1231 7.40113 19.0222 6.29939C17.9212 5.19764 17.4668 3.79242 18.0297 3.22872C18.5926 2.66576 19.9992 3.1195 21.1002 4.22125C22.2011 5.32226 22.6555 6.72821 22.0926 7.29191Z"
                fill="#DFB47E"
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_dd_54_162161"
              x="0.884766"
              y="0.43335"
              width="24.0151"
              height="24.1003"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.372549 0 0 0 0 0.54902 0 0 0 0 1 0 0 0 0.3 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_54_162161" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="0.65" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_54_162161" result="effect2_dropShadow_54_162161" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_54_162161" result="shape" />
            </filter>
            <clipPath id="clip0_54_162161">
              <rect width="24" height="24" fill="white" transform="translate(0.899902 0.434082)" />
            </clipPath>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.NEWBIE_0 && (
        <svg width={size} height={size} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_54_162179)">
            <path
              d="M19.5927 5.54269C17.7595 3.70952 15.2733 3.22355 14.0382 4.45862L13.7487 4.82291C10.8996 4.16543 7.78518 4.94605 5.56499 7.16624C2.13979 10.5914 2.13979 16.1459 5.56499 19.5711C8.99019 22.9963 14.5447 22.9963 17.9699 19.5711C20.1901 17.3509 20.9707 14.2373 20.3132 11.3874L20.6775 11.0979C21.9118 9.86359 21.4259 7.3766 19.5927 5.54343V5.54269Z"
              fill="#EFECF2"
            />
            <path
              d="M11.7678 22.4328C9.34682 22.4328 7.0702 21.4902 5.35797 19.778C3.64573 18.0657 2.70312 15.7891 2.70312 13.3681C2.70312 10.9471 3.64573 8.67045 5.35797 6.95822C7.5393 4.77688 10.62 3.86432 13.6333 4.49688L13.8312 4.25133C15.1777 2.90486 17.8552 3.39082 19.7998 5.33541C21.7444 7.27999 22.2311 9.95829 20.8846 11.3048L20.8597 11.3268L20.6383 11.5027C21.2709 14.5159 20.3576 17.5966 18.177 19.778C16.4648 21.4902 14.1889 22.4328 11.7671 22.4328H11.7678ZM11.7495 4.88683C9.52934 4.88683 7.38758 5.75833 5.77283 7.37308C4.17128 8.97464 3.28951 11.1039 3.28951 13.3681C3.28951 15.6323 4.17128 17.7616 5.77283 19.3631C7.37438 20.9647 9.50295 21.8464 11.7678 21.8464C14.0327 21.8464 16.1613 20.9647 17.7629 19.3631C19.8438 17.2822 20.6904 14.3254 20.0278 11.4528L19.986 11.2725L20.4815 10.8782C21.5846 9.75599 21.0957 7.45957 19.3857 5.74954C17.6756 4.0395 15.38 3.55061 14.2578 4.65374L13.8634 5.14923L13.6831 5.10745C13.0396 4.95866 12.3909 4.88609 11.7495 4.88609V4.88683Z"
              fill="#231815"
            />
            <path
              d="M11.7698 20.8717C15.9135 20.8717 19.2726 17.5126 19.2726 13.369C19.2726 9.22531 15.9135 5.86621 11.7698 5.86621C7.62618 5.86621 4.26709 9.22531 4.26709 13.369C4.26709 17.5126 7.62618 20.8717 11.7698 20.8717Z"
              fill="#E1E4E5"
            />
            <path
              d="M19.1546 11.9321C17.6638 13.1276 15.437 12.8498 13.8603 11.2725C12.2837 9.69509 12.0066 7.46978 13.2007 5.97964L14.2547 4.65441C15.3769 3.55128 17.6725 4.04018 19.3826 5.75021C21.0926 7.46025 21.5822 9.75667 20.4784 10.8789L19.1539 11.9321H19.1546Z"
              fill="#EFECF2"
            />
            <path
              d="M15.3281 9.80575C13.7742 8.25184 13.2288 6.21417 13.9699 5.01282L13.201 5.97961C12.0062 7.46975 12.284 9.6958 13.8606 11.2724C15.4373 12.8491 17.6641 13.1269 19.1549 11.9321L20.1203 11.164C18.9189 11.905 16.8812 11.3597 15.3273 9.80575H15.3281Z"
              fill="#EFECF2"
            />
            <mask
              id="mask0_54_162179"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="12"
              y="5"
              width="9"
              height="8"
            >
              <path
                d="M15.3334 9.80795C13.7795 8.25404 13.2342 6.21636 13.9752 5.01501L13.2063 5.98181C12.0116 7.47195 12.2894 9.698 13.866 11.2746C15.4427 12.8513 17.6694 13.1291 19.1603 11.9343L20.1256 11.1662C18.9243 11.9072 16.8866 11.3619 15.3327 9.80795H15.3334Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_54_162179)">
              <path
                d="M17.5114 7.63348L12.2378 12.9071L15.8021 16.4714L21.0757 11.1978L17.5114 7.63348Z"
                fill="#B0A4BC"
              />
            </g>
            <path
              d="M8.80535 11.2938C9.45711 10.5382 9.49693 9.5043 8.89428 8.98448C8.29164 8.46466 7.27474 8.6558 6.62299 9.4114C5.97123 10.167 5.93141 11.2009 6.53405 11.7208C7.1367 12.2406 8.15359 12.0494 8.80535 11.2938Z"
              fill="white"
            />
            <path
              d="M22.0456 7.59295C22.7779 6.86071 22.3645 5.25842 21.1206 4.01529C19.8775 2.77216 18.2752 2.35803 17.5429 3.09027L15.9436 5.06345C15.2546 5.9071 15.4708 7.38478 16.6106 8.52456C17.7504 9.66434 19.2288 9.88057 20.0717 9.19157L22.0449 7.59222L22.0456 7.59295Z"
              fill="#B16C3C"
            />
            <path
              d="M18.8993 9.87615C18.0704 9.87615 17.149 9.47887 16.4021 8.7327C15.1985 7.52916 14.9032 5.87263 15.7153 4.87871L17.3344 2.88355C18.1942 2.02377 19.9482 2.42984 21.327 3.80857C22.7057 5.1873 23.1118 6.94058 22.252 7.80109L22.2293 7.82161L20.2561 9.42097C19.8793 9.72882 19.4066 9.87688 18.9001 9.87688L18.8993 9.87615ZM17.7588 3.28815L16.1697 5.24887C15.5489 6.0097 15.8267 7.32905 16.8162 8.31857C17.8057 9.30809 19.1251 9.58662 19.8845 8.96579L21.8459 7.37596C22.4382 6.7632 22.013 5.3251 20.9114 4.2227C19.8097 3.12103 18.3709 2.69591 17.7581 3.28815H17.7588Z"
              fill="#231815"
            />
            <path
              d="M21.9061 7.29257C21.3432 7.8555 19.9366 7.40178 18.8356 6.30012C17.7347 5.19846 17.2803 3.79334 17.8432 3.22968C18.4061 2.66676 19.8127 3.12047 20.9136 4.22213C22.0146 5.32306 22.469 6.72891 21.9061 7.29257Z"
              fill="#DFB47E"
            />
          </g>
          <defs>
            <clipPath id="clip0_54_162179">
              <rect width="20" height="20" fill="white" transform="translate(2.7002 2.43408)" />
            </clipPath>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.LOADING && (
        <svg width={size} height={size} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18.9689 5.54308C17.1356 3.7095 14.6492 3.22343 13.414 4.45877L13.1245 4.82314C10.2752 4.16552 7.16053 4.94631 4.94018 7.16698C1.51473 10.5929 1.51473 16.1487 4.94018 19.5746C8.36563 23.0006 13.9205 23.0006 17.346 19.5746C19.5663 17.3539 20.347 14.2396 19.6895 11.3891L20.0538 11.0995C21.2882 9.86493 20.8022 7.37666 18.9689 5.54308Z"
            fill="#EAEAEC"
          />
          <path
            d="M11.1435 22.4324C8.822 22.4324 6.5005 21.549 4.73316 19.7814C3.0208 18.0688 2.07812 15.7916 2.07812 13.3701C2.07812 10.9485 3.0208 8.67139 4.73316 6.95878C6.91393 4.7777 9.99558 3.86421 13.0091 4.4969L13.207 4.2513C14.5536 2.90453 17.2313 3.39133 19.1761 5.33561C21.1208 7.28063 21.6075 9.95951 20.2609 11.3063L20.236 11.3283L20.0154 11.5042C20.648 14.5182 19.7346 17.5995 17.5539 19.7814C15.7865 21.549 13.465 22.4324 11.1435 22.4324ZM11.1252 4.88693C8.90484 4.88693 6.76292 5.75863 5.14806 7.37374C3.54638 8.97564 2.66455 11.1047 2.66455 13.3701C2.66455 15.6355 3.54638 17.7645 5.14806 19.3664C8.45402 22.6729 13.833 22.6729 17.139 19.3664C19.22 17.285 20.0667 14.3275 19.404 11.4544L19.3622 11.274L19.8578 10.8796C20.3753 10.3532 20.5586 9.54456 20.3738 8.60101C20.1796 7.60834 19.6071 6.59588 18.7612 5.74984C17.051 4.03943 14.7552 3.55042 13.6329 4.6538L13.2385 5.1494L13.0582 5.10761C12.4146 4.95878 11.7659 4.8862 11.1245 4.8862L11.1252 4.88693Z"
            fill="#EAEAEC"
          />
          <path
            d="M11.1425 20.875C15.2864 20.875 18.6458 17.5152 18.6458 13.3706C18.6458 9.22604 15.2864 5.86621 11.1425 5.86621C6.9985 5.86621 3.63916 9.22604 3.63916 13.3706C3.63916 17.5152 6.9985 20.875 11.1425 20.875Z"
            fill="#EAEAEC"
          />
          <mask
            id="mask0_54_162188"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="3"
            y="5"
            width="16"
            height="16"
          >
            <path
              d="M11.1454 20.8783C15.2893 20.8783 18.6487 17.5185 18.6487 13.3739C18.6487 9.22934 15.2893 5.86951 11.1454 5.86951C7.00143 5.86951 3.64209 9.22934 3.64209 13.3739C3.64209 17.5185 7.00143 20.8783 11.1454 20.8783Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_54_162188)">
            <path
              d="M8.33371 20.2389C12.8594 20.2389 16.5283 16.5695 16.5283 12.0432C16.5283 7.51677 12.8594 3.84741 8.33371 3.84741C3.80798 3.84741 0.13916 7.51677 0.13916 12.0432C0.13916 16.5695 3.80798 20.2389 8.33371 20.2389Z"
              fill="#EAEAEC"
            />
          </g>
          <path
            d="M18.5355 11.9339C17.0445 13.1296 14.8176 12.8518 13.2408 11.274C11.6641 9.69707 11.387 7.47053 12.5811 5.98006L13.6352 4.65454C14.7574 3.55117 17.0533 4.04017 18.7635 5.75059C20.4736 7.461 20.9633 9.75792 19.8593 10.8804L18.5348 11.9339H18.5355Z"
            fill="#EAEAEC"
          />
          <path
            d="M14.7086 9.8068C13.1546 8.25255 12.6093 6.21443 13.3503 5.01282L12.5814 5.97983C11.3866 7.47029 11.6644 9.69683 13.2411 11.2738C14.8179 12.8508 17.0448 13.1287 18.5358 11.9336L19.5012 11.1653C18.2998 11.9065 16.2619 11.3611 14.7079 9.8068H14.7086Z"
            fill="#EAEAEC"
          />
          <mask
            id="mask1_54_162188"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="11"
            y="5"
            width="9"
            height="8"
          >
            <path
              d="M14.7072 9.809C13.1532 8.25475 12.6078 6.21663 13.3489 5.01501L12.5799 5.98202C11.3851 7.47249 11.6629 9.69903 13.2397 11.276C14.8164 12.853 17.0434 13.1308 18.5343 11.9358L19.4997 11.1675C18.2983 11.9087 16.2605 11.3633 14.7065 9.809H14.7072Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_54_162188)">
            <path d="M16.8814 7.63232L11.6074 12.9071L15.172 16.4722L20.446 11.1974L16.8814 7.63232Z" fill="#EAEAEC" />
          </g>
          <path
            d="M21.4299 7.59402C22.1622 6.86162 21.7487 5.25898 20.5048 4.01557C19.2616 2.77217 17.6592 2.35795 16.9269 3.09035L15.3274 5.06396C14.6383 5.9078 14.8546 7.38581 15.9945 8.52584C17.1343 9.66587 18.6128 9.88214 19.4558 9.19299L21.4291 7.59329L21.4299 7.59402Z"
            fill="#EAEAEC"
          />
          <path
            d="M18.2834 9.87778C17.4543 9.87778 16.5329 9.48042 15.786 8.73409C14.5823 7.53028 14.2869 5.87339 15.0991 4.87925L16.7184 2.88365C17.5782 2.02368 19.3324 2.42984 20.7112 3.80887C21.3489 4.4467 21.8034 5.19817 21.9911 5.92397C22.1927 6.70476 22.0666 7.37192 21.6356 7.80227L21.6128 7.8228L19.6395 9.42251C19.2627 9.73042 18.7899 9.87852 18.2834 9.87852V9.87778ZM17.1428 3.28834L15.5536 5.24948C14.9327 6.01048 15.2105 7.33013 16.2001 8.31987C17.1897 9.3096 18.5092 9.58819 19.2693 8.96723L21.2309 7.37705C21.5007 7.09773 21.5688 6.63438 21.423 6.06987C21.261 5.44377 20.8607 4.78834 20.2963 4.22309C19.1946 3.12119 17.7556 2.69597 17.1428 3.28834Z"
            fill="#EAEAEC"
          />
          <path
            d="M21.2868 7.29352C20.7238 7.85657 19.3171 7.40276 18.2161 6.30085C17.1151 5.19894 16.6606 3.79352 17.2236 3.22973C17.7866 2.66668 19.1932 3.1205 20.2942 4.2224C21.3953 5.32358 21.8497 6.72974 21.2868 7.29352Z"
            fill="#EAEAEC"
          />
          <path
            d="M8.18597 11.296C8.83778 10.5403 8.8776 9.50609 8.27491 8.98616C7.67222 8.46622 6.65525 8.6574 6.00344 9.41317C5.35164 10.1689 5.31182 11.2031 5.91451 11.723C6.51719 12.243 7.53416 12.0518 8.18597 11.296Z"
            fill="#EAEAEC"
          />
          <g opacity="0.8" clipPath="url(#clip0_54_162188)">
            <path
              opacity="0.3"
              d="M8.45777 10.2288C8.33721 10.2288 8.2216 10.2767 8.13635 10.3619C8.05111 10.4472 8.00322 10.5628 8.00322 10.6833C8.00322 10.8039 8.05111 10.9195 8.13635 11.0048L9.10059 11.969C9.18583 12.0542 9.30145 12.1021 9.422 12.1021C9.54256 12.1021 9.65817 12.0542 9.74341 11.969C9.82866 11.8838 9.87655 11.7681 9.87655 11.6476C9.87655 11.527 9.82866 11.4114 9.74341 11.3262L8.77918 10.3619C8.69393 10.2767 8.57832 10.2288 8.45777 10.2288Z"
              fill="#636363"
            />
            <path
              opacity="0.9"
              d="M12.8723 14.6467C12.7518 14.6467 12.6361 14.6945 12.5509 14.7798C12.4657 14.865 12.4178 14.9806 12.4178 15.1012C12.4178 15.2217 12.4657 15.3374 12.5509 15.4226L13.5151 16.3868C13.6004 16.4721 13.716 16.52 13.8366 16.52C13.9571 16.52 14.0727 16.4721 14.158 16.3868C14.2432 16.3016 14.2911 16.186 14.2911 16.0654C14.2911 15.9449 14.2432 15.8293 14.158 15.744L13.1937 14.7798C13.1085 14.6945 12.9929 14.6467 12.8723 14.6467Z"
              fill="#636363"
            />
            <path
              opacity="0.7"
              d="M8.00297 16.0647C8.00297 16.1852 8.05086 16.3009 8.13611 16.3861C8.22135 16.4714 8.33697 16.5192 8.45752 16.5192C8.57807 16.5192 8.69369 16.4714 8.77893 16.3861L9.74317 15.4219C9.82841 15.3366 9.8763 15.221 9.8763 15.1005C9.8763 14.9799 9.82841 14.8643 9.74317 14.779C9.65792 14.6938 9.54231 14.6459 9.42176 14.6459C9.3012 14.6459 9.18559 14.6938 9.10034 14.779L8.13611 15.7433C8.05086 15.8285 8.00297 15.9441 8.00297 16.0647Z"
              fill="#636363"
            />
            <path
              d="M12.418 11.6457C12.418 11.7663 12.4659 11.8819 12.5511 11.9672C12.6364 12.0524 12.752 12.1003 12.8726 12.1003C12.9931 12.1003 13.1087 12.0524 13.194 11.9672L14.1582 11.0029C14.2435 10.9177 14.2913 10.8021 14.2913 10.6815C14.2913 10.561 14.2435 10.4453 14.1582 10.3601C14.073 10.2749 13.9573 10.227 13.8368 10.227C13.7162 10.227 13.6006 10.2749 13.5154 10.3601L12.5511 11.3243C12.4659 11.4096 12.418 11.5252 12.418 11.6457Z"
              fill="#636363"
            />
            <path
              opacity="0.5"
              d="M7.02034 13.0538C6.9351 13.139 6.88721 13.2546 6.88721 13.3752C6.88721 13.4957 6.9351 13.6113 7.02034 13.6966C7.10558 13.7818 7.2212 13.8297 7.34175 13.8297L8.70539 13.8297C8.82594 13.8297 8.94156 13.7818 9.0268 13.6966C9.11204 13.6113 9.15993 13.4957 9.15993 13.3752C9.15993 13.2546 9.11204 13.139 9.0268 13.0538C8.94156 12.9685 8.82594 12.9206 8.70539 12.9206L7.34175 12.9206C7.2212 12.9206 7.10558 12.9685 7.02034 13.0538Z"
              fill="#636363"
            />
            <path
              d="M13.2703 13.0538C13.1851 13.139 13.1372 13.2546 13.1372 13.3752C13.1372 13.4957 13.1851 13.6113 13.2703 13.6966C13.3556 13.7818 13.4712 13.8297 13.5918 13.8297L14.9554 13.8297C15.0759 13.8297 15.1916 13.7818 15.2768 13.6966C15.362 13.6113 15.4099 13.4957 15.4099 13.3752C15.4099 13.2546 15.362 13.139 15.2768 13.0538C15.1916 12.9685 15.0759 12.9206 14.9554 12.9206L13.5918 12.9206C13.4712 12.9206 13.3556 12.9685 13.2703 13.0538Z"
              fill="#636363"
            />
            <path
              opacity="0.8"
              d="M10.8232 17.5031C10.9084 17.5883 11.024 17.6362 11.1446 17.6362C11.2651 17.6362 11.3807 17.5883 11.466 17.5031C11.5512 17.4179 11.5991 17.3022 11.5991 17.1817L11.5991 15.818C11.5991 15.6975 11.5512 15.5819 11.466 15.4966C11.3807 15.4114 11.2651 15.3635 11.1446 15.3635C11.024 15.3635 10.9084 15.4114 10.8232 15.4966C10.7379 15.5819 10.69 15.6975 10.69 15.818L10.69 17.1817C10.69 17.3022 10.7379 17.4179 10.8232 17.5031Z"
              fill="#636363"
            />
            <path
              opacity="0.2"
              d="M10.8232 11.2531C10.9084 11.3383 11.024 11.3862 11.1446 11.3862C11.2651 11.3862 11.3807 11.3383 11.466 11.2531C11.5512 11.1679 11.5991 11.0522 11.5991 10.9317L11.5991 9.56805C11.5991 9.4475 11.5512 9.33188 11.466 9.24664C11.3807 9.16139 11.2651 9.1135 11.1446 9.1135C11.024 9.1135 10.9084 9.16139 10.8232 9.24664C10.7379 9.33188 10.69 9.4475 10.69 9.56805L10.69 10.9317C10.69 11.0522 10.7379 11.1679 10.8232 11.2531Z"
              fill="#636363"
            />
          </g>
          <defs>
            <clipPath id="clip0_54_162188">
              <rect width="10" height="10" fill="white" transform="translate(6.15039 8.37341)" />
            </clipPath>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.ERROR && (
        <svg width={size} height={size} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M19.3825 5.54308C17.5492 3.7095 15.0627 3.22343 13.8276 4.45877L13.538 4.82314C10.6887 4.16552 7.5741 4.94631 5.35376 7.16698C1.92831 10.5929 1.92831 16.1487 5.35376 19.5746C8.77921 23.0006 14.3341 23.0006 17.7596 19.5746C19.9799 17.3539 20.7606 14.2396 20.1031 11.3891L20.4674 11.0995C21.7018 9.86493 21.2158 7.37739 19.3825 5.54381V5.54308Z"
            fill="#FF4444"
          />
          <path
            d="M11.5571 22.4324C9.23558 22.4324 6.91407 21.549 5.14673 19.7814C3.43438 18.0688 2.4917 15.7916 2.4917 13.3701C2.4917 10.9485 3.43438 8.67139 5.14673 6.95878C7.3275 4.7777 10.4092 3.86421 13.4226 4.4969L13.6206 4.2513C14.9671 2.90453 17.6449 3.39133 19.5896 5.33561C21.5344 7.28063 22.0211 9.95951 20.6745 11.3063L20.6496 11.3283L20.4289 11.5042C21.0616 14.5182 20.1482 17.5995 17.9674 19.7814C16.2001 21.549 13.8786 22.4324 11.5571 22.4324ZM11.5388 4.88693C9.31841 4.88693 7.1765 5.75863 5.56163 7.37374C3.95996 8.97564 3.07812 11.1047 3.07812 13.3701C3.07812 15.6355 3.95996 17.7645 5.56163 19.3664C8.8676 22.6729 14.2466 22.6729 17.5525 19.3664C19.6336 17.285 20.4803 14.3275 19.8176 11.4544L19.7758 11.274L20.2713 10.8796C20.7889 10.3532 20.9721 9.54456 20.7874 8.60101C20.5931 7.60834 20.0207 6.59588 19.1747 5.74984C17.4646 4.03943 15.1687 3.55042 14.0465 4.6538L13.6521 5.1494L13.4718 5.10761C12.8282 4.95878 12.1794 4.8862 11.538 4.8862L11.5388 4.88693Z"
            fill="#FF4444"
          />
          <path
            d="M11.5555 20.875C15.6995 20.875 19.0588 17.5152 19.0588 13.3706C19.0588 9.22604 15.6995 5.86621 11.5555 5.86621C7.41159 5.86621 4.05225 9.22604 4.05225 13.3706C4.05225 17.5152 7.41159 20.875 11.5555 20.875Z"
            fill="#FF4444"
          />
          <mask
            id="mask0_54_162206"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="4"
            y="5"
            width="16"
            height="16"
          >
            <path
              d="M11.5595 20.8783C15.7034 20.8783 19.0627 17.5185 19.0627 13.3739C19.0627 9.22934 15.7034 5.86951 11.5595 5.86951C7.41549 5.86951 4.05615 9.22934 4.05615 13.3739C4.05615 17.5185 7.41549 20.8783 11.5595 20.8783Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_54_162206)">
            <path
              d="M8.73947 20.2399C13.2652 20.2399 16.934 16.5705 16.934 12.0441C16.934 7.51775 13.2652 3.84839 8.73947 3.84839C4.21374 3.84839 0.544922 7.51775 0.544922 12.0441C0.544922 16.5705 4.21374 20.2399 8.73947 20.2399Z"
              fill="#FF4444"
            />
          </g>
          <path
            d="M18.9486 11.9339C17.4576 13.1296 15.2306 12.8518 13.6539 11.274C12.0771 9.69707 11.8001 7.47053 12.9942 5.98006L14.0483 4.65454C15.1705 3.55117 17.4664 4.04017 19.1765 5.75059C20.8867 7.461 21.3764 9.75792 20.2724 10.8804L18.9478 11.9339H18.9486Z"
            fill="#FF4444"
          />
          <path
            d="M15.1217 9.8068C13.5677 8.25255 13.0223 6.21443 13.7634 5.01282L12.9945 5.97983C11.7996 7.47029 12.0775 9.69683 13.6542 11.2738C15.231 12.8508 17.4579 13.1287 18.9489 11.9336L19.9143 11.1653C18.7128 11.9065 16.675 11.3611 15.121 9.8068H15.1217Z"
            fill="#FF4444"
          />
          <mask
            id="mask1_54_162206"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="12"
            y="5"
            width="8"
            height="8"
          >
            <path
              d="M15.1169 9.809C13.5628 8.25475 13.0175 6.21663 13.7585 5.01501L12.9896 5.98202C11.7948 7.47249 12.0726 9.69903 13.6493 11.276C15.2261 12.853 17.453 13.1308 18.944 11.9358L19.9094 11.1675C18.708 11.9087 16.6701 11.3633 15.1161 9.809H15.1169Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_54_162206)">
            <path
              d="M17.2911 7.63232L12.0171 12.9071L15.5816 16.4722L20.8557 11.1974L17.2911 7.63232Z"
              fill="#FF4444"
            />
          </g>
          <path
            d="M21.8435 7.59402C22.5757 6.86162 22.1623 5.25898 20.9184 4.01557C19.6751 2.77217 18.0727 2.35795 17.3404 3.09035L15.741 5.06396C15.0519 5.9078 15.2682 7.38581 16.408 8.52584C17.5479 9.66587 19.0264 9.88214 19.8694 9.19299L21.8427 7.59329L21.8435 7.59402Z"
            fill="#FF4444"
          />
          <path
            d="M18.697 9.87778C17.8679 9.87778 16.9465 9.48042 16.1995 8.73409C14.9959 7.53028 14.7005 5.87339 15.5127 4.87925L17.132 2.88365C17.9918 2.02368 19.7459 2.42984 21.1248 3.80887C21.7625 4.4467 22.217 5.19817 22.4046 5.92397C22.6062 6.70476 22.4801 7.37192 22.0491 7.80227L22.0264 7.8228L20.0531 9.42251C19.6763 9.73042 19.2035 9.87852 18.697 9.87852V9.87778ZM17.5564 3.28834L15.9672 5.24948C15.3463 6.01048 15.6241 7.33013 16.6137 8.31987C17.6033 9.3096 18.9228 9.58819 19.6829 8.96723L21.6445 7.37705C21.9142 7.09773 21.9824 6.63438 21.8365 6.06987C21.6745 5.44377 21.2743 4.78834 20.7099 4.22309C19.6081 3.12119 18.1692 2.69597 17.5564 3.28834Z"
            fill="#FF4444"
          />
          <path
            d="M21.696 7.29352C21.133 7.85657 19.7263 7.40276 18.6253 6.30085C17.5243 5.19894 17.0698 3.79352 17.6328 3.22973C18.1957 2.66668 19.6024 3.1205 20.7034 4.2224C21.8044 5.32358 22.2589 6.72974 21.696 7.29352Z"
            fill="#FF4444"
          />
          <path
            d="M8.59515 11.296C9.24696 10.5403 9.28677 9.50609 8.68409 8.98616C8.0814 8.46622 7.06443 8.6574 6.41262 9.41317C5.76082 10.1689 5.721 11.2031 6.32368 11.723C6.92637 12.243 7.94334 12.0518 8.59515 11.296Z"
            fill="#FF4444"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.5434 14.7285C12.0037 14.7285 12.3768 14.3554 12.3768 13.8951V9.72791C12.3768 9.26762 12.0037 8.89448 11.5434 8.89448C11.0831 8.89448 10.71 9.26762 10.71 9.72791V13.8951C10.71 14.3554 11.0831 14.7285 11.5434 14.7285Z"
            fill="#141111"
          />
          <path
            d="M12.5899 16.8117C12.5899 16.2364 12.1235 15.7699 11.5481 15.7699C10.9728 15.7699 10.5063 16.2364 10.5063 16.8117C10.5063 17.3871 10.9728 17.8535 11.5481 17.8535C12.1235 17.8535 12.5899 17.3871 12.5899 16.8117Z"
            fill="#141111"
          />
        </svg>
      )}
      {variant === ShampooIconVariant.NEWBIE_REFILL && (
        <svg width="100%" height="100%" viewBox="12 3 39 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_f_5873_625282)">
            <ellipse cx="31.9987" cy="45.5632" rx="18.987" ry="5.16817" fill="url(#paint0_radial_5873_625282)" />
          </g>
          <g filter="url(#filter1_df_5873_625282)">
            <rect
              x="12.2852"
              y="18.0503"
              width="3.47919"
              height="28.5421"
              fill="url(#paint1_linear_5873_625282)"
              fillOpacity="0.5"
              shapeRendering="crispEdges"
            />
          </g>
          <g filter="url(#filter2_df_5873_625282)">
            <rect
              x="19.5039"
              y="3"
              width="17.3253"
              height="43.3122"
              fill="url(#paint2_linear_5873_625282)"
              shapeRendering="crispEdges"
            />
          </g>
          <g filter="url(#filter3_df_5873_625282)">
            <rect
              x="13.5391"
              y="11.8667"
              width="36.4619"
              height="34.4457"
              fill="url(#paint3_linear_5873_625282)"
              fillOpacity="0.5"
              shapeRendering="crispEdges"
            />
          </g>
          <g filter="url(#filter4_df_5873_625282)">
            <rect
              x="39.3203"
              y="6.46338"
              width="7.89882"
              height="39.849"
              fill="url(#paint4_linear_5873_625282)"
              shapeRendering="crispEdges"
            />
          </g>
          <g filter="url(#filter5_df_5873_625282)">
            <rect
              x="48.9453"
              y="3.9082"
              width="2.03983"
              height="42.4041"
              fill="url(#paint5_linear_5873_625282)"
              fillOpacity="0.5"
              shapeRendering="crispEdges"
            />
          </g>
          <g filter="url(#filter6_df_5873_625282)">
            <rect
              x="16.7422"
              y="9.32275"
              width="1.41728"
              height="36.9876"
              fill="url(#paint6_linear_5873_625282)"
              shapeRendering="crispEdges"
            />
          </g>
          <g filter="url(#filter7_df_5873_625282)">
            <path
              d="M32.0039 42.0527C32.0039 42.0527 32.3256 42.5226 33.1104 42.7236C33.4766 42.8174 34.0708 42.8839 34.6006 42.9297C37.9447 43.0128 41.0203 43.2545 43.6035 43.6123C44.3704 43.6221 45.4649 43.6104 46.6162 43.5068C48.7621 43.3138 52.7051 42.6641 52.7051 42.6641C52.7051 42.6641 49.2156 43.399 48.1797 43.7988C47.6283 44.0117 47.554 44.2137 47.6045 44.3564C49.5373 44.8383 50.8413 45.4122 51.292 46.0371C51.5377 46.1357 51.9012 46.2474 52.4033 46.3154C53.4809 46.4615 55.9965 46.5213 56.0029 46.5215C55.9991 46.5216 53.4815 46.5814 52.4033 46.7275C51.9054 46.795 51.5435 46.905 51.2979 47.0029C50.8523 47.6309 49.5455 48.2075 47.6045 48.6914C47.5525 48.8342 47.6246 49.0371 48.1787 49.251C49.2146 49.6508 52.7041 50.3857 52.7041 50.3857C52.7041 50.3857 48.7611 49.736 46.6152 49.543C45.4581 49.4389 44.3583 49.4264 43.5908 49.4365C41.0277 49.7909 37.9812 50.0317 34.6689 50.1162C34.1227 50.162 33.4924 50.2313 33.1104 50.3291C32.3256 50.5301 32.0039 51 32.0039 51C32.0021 50.9974 31.6808 50.5296 30.8984 50.3291C30.5154 50.231 29.8824 50.161 29.335 50.1152C26.0029 50.0302 22.9397 49.7886 20.3672 49.4307C19.6019 49.4216 18.5212 49.4349 17.3848 49.5371C15.239 49.7301 11.2959 50.3799 11.2959 50.3799C11.2959 50.3799 14.784 49.645 15.8203 49.2451C16.3699 49.033 16.4449 48.8321 16.3955 48.6895C14.4579 48.2059 13.1526 47.6311 12.707 47.0039C12.4614 46.9058 12.0989 46.7952 11.5996 46.7275C10.5206 46.5813 8 46.5215 8 46.5215C8.00366 46.5214 10.5214 46.4615 11.5996 46.3154C12.1025 46.2472 12.4662 46.1348 12.7119 46.0361C13.1631 45.4111 14.4684 44.8355 16.4023 44.3535C16.4493 44.2111 16.3721 44.0112 15.8271 43.8008C14.7912 43.401 11.3018 42.667 11.3018 42.667C11.3018 42.667 15.2448 43.3167 17.3906 43.5098C18.5251 43.6118 19.6041 43.6242 20.3691 43.6152C22.9605 43.2548 26.05 43.013 29.4102 42.9297C29.9394 42.8839 30.5329 42.8173 30.8984 42.7236C31.6829 42.5225 32.0039 42.0527 32.0039 42.0527ZM23.543 48.2197C23.1642 48.3143 22.8011 48.4114 22.4922 48.501C25.2824 48.7976 28.529 48.9707 32.0029 48.9707C35.4686 48.9707 38.7076 48.7983 41.4932 48.5029C41.1821 48.4131 40.8173 48.3164 40.4375 48.2217C38.2225 48.6037 35.2593 48.8408 32.0029 48.8408L30.7324 48.8291C27.9668 48.7768 25.4698 48.5539 23.543 48.2197ZM42.9316 44.7129C42.3556 44.7782 41.7161 44.8615 41.0859 44.9492C43.1562 45.3627 44.4232 45.9164 44.4238 46.5264C44.4238 47.1351 43.1627 47.6884 41.1006 48.1016C41.7228 48.1881 42.3536 48.2703 42.9229 48.335C43.8659 48.2132 44.7454 48.0786 45.5498 47.9287C47.2753 47.6072 48.5985 47.2358 49.4619 46.8555C49.5238 46.8282 49.5812 46.7997 49.6357 46.7734C49.5495 46.7577 49.4585 46.7406 49.3623 46.7275C48.2908 46.5824 45.7991 46.5223 45.7637 46.5215C45.7994 46.5206 48.2909 46.4606 49.3623 46.3154C49.456 46.3027 49.5447 46.2858 49.6289 46.2705C49.5765 46.2454 49.521 46.2194 49.4619 46.1934C48.5985 45.813 47.2752 45.4416 45.5498 45.1201C44.7479 44.9707 43.8714 44.8343 42.9316 44.7129ZM21.0605 44.7148C20.1254 44.8359 19.2535 44.9714 18.4551 45.1201C16.7295 45.4416 15.4064 45.813 14.543 46.1934C14.4833 46.2196 14.4269 46.2452 14.374 46.2705C14.4582 46.2858 14.5469 46.3027 14.6406 46.3154C15.7119 46.4606 18.2031 46.5206 18.2393 46.5215C18.2035 46.5223 15.712 46.5824 14.6406 46.7275C14.5444 46.7406 14.4534 46.7577 14.3672 46.7734C14.4222 46.7999 14.4806 46.828 14.543 46.8555C15.4064 47.2358 16.7298 47.6072 18.4551 47.9287C19.2506 48.0769 20.1194 48.2113 21.0508 48.332C21.6228 48.2674 22.2583 48.1839 22.8857 48.0967C20.8351 47.6839 19.5811 47.1332 19.5811 46.5264C19.5817 45.9175 20.8446 45.3643 22.9082 44.9512C22.2768 44.8634 21.6366 44.7799 21.0605 44.7148ZM27.4121 47.4922C28.4598 47.5717 29.585 47.6263 30.7637 47.6484C30.4 47.4835 29.9498 47.3198 29.4043 47.1895L27.4121 47.4922ZM34.584 47.1904C34.0406 47.3206 33.5921 47.484 33.2295 47.6484C34.4066 47.6265 35.5304 47.5723 36.5771 47.4932L34.584 47.1904ZM35.5576 46.043C37.91 46.3836 42.2373 46.5273 42.2373 46.5273C42.2373 46.5273 37.9232 46.6685 35.5684 47.0078L37.3926 47.4238C38.5819 47.3142 39.6542 47.1724 40.5693 47.002C41.3655 46.8536 42.0113 46.6904 42.499 46.5264C42.0113 46.3624 41.3653 46.1991 40.5693 46.0508C39.6502 45.8795 38.5725 45.7368 37.377 45.627L35.5576 46.043ZM26.6123 45.6289C25.4231 45.7385 24.3506 45.8803 23.4355 46.0508C22.6393 46.1992 21.9936 46.3623 21.5059 46.5264C21.9936 46.6904 22.6394 46.8536 23.4355 47.002C24.3466 47.1717 25.4137 47.3134 26.5967 47.4229L28.418 47.0068C26.0721 46.6698 21.7962 46.5286 21.7578 46.5273C21.796 46.5261 26.0852 46.3823 28.4287 46.0439L26.6123 45.6289ZM30.7627 45.4043C29.5909 45.4264 28.4721 45.4808 27.4297 45.5596L29.4141 45.8613C29.955 45.7314 30.4013 45.5681 30.7627 45.4043ZM33.2295 45.4043C33.5901 45.5678 34.0358 45.7295 34.5752 45.8594L36.5547 45.5576C35.5144 45.4794 34.3982 45.4261 33.2295 45.4043ZM32.0029 44.0781C28.5318 44.0781 25.2876 44.2497 22.499 44.5459C22.8133 44.637 23.1837 44.7349 23.5693 44.8311C25.7844 44.4492 28.7471 44.2119 32.0029 44.2119L33.2725 44.2236C36.0257 44.2757 38.5132 44.4965 40.4365 44.8281C40.819 44.7328 41.1864 44.6354 41.499 44.5449C38.7122 44.2492 35.4711 44.0781 32.0029 44.0781Z"
              fill="url(#paint7_linear_5873_625282)"
            />
          </g>
          <g clipPath="url(#clip0_5873_625282)">
            <g filter="url(#filter8_dd_5873_625282)">
              <path
                d="M31.7536 42.4721C28.5248 42.4721 25.4886 41.2598 23.2051 39.0575C18.4915 34.5116 18.4915 27.1147 23.2051 22.5688C26.1142 19.7632 30.2228 18.5894 34.2413 19.403L34.5053 19.0872C35.3968 18.2274 36.7301 17.9135 38.2609 18.201C39.735 18.4782 41.2287 19.289 42.4652 20.4815C43.7018 21.6741 44.5425 23.1147 44.8299 24.5373C45.129 26.0136 44.8025 27.3005 43.912 28.1593L43.8787 28.1876L43.5835 28.4139C44.4271 32.2895 43.2091 36.2519 40.301 39.0575C38.0175 41.2598 34.9823 42.4721 31.7526 42.4721H31.7536ZM31.7291 19.9046C28.7682 19.9046 25.9119 21.0255 23.7584 23.1024C19.3498 27.3542 19.3498 34.2721 23.7584 38.5239C25.8943 40.5838 28.734 41.7179 31.7536 41.7179C34.7731 41.7179 37.6128 40.5838 39.7487 38.5239C42.5239 35.8474 43.6529 32.0444 42.7692 28.3497L42.7135 28.1178L43.3743 27.6106C44.0645 26.9337 44.3088 25.8939 44.0625 24.6806C43.8035 23.4041 43.04 22.1021 41.9119 21.0142C40.7839 19.9263 39.4339 19.19 38.1104 18.9411C36.8523 18.7045 35.7741 18.9402 35.0722 19.6057L34.5463 20.243L34.3059 20.1893C33.4476 19.9979 32.5825 19.9046 31.7272 19.9046H31.7291Z"
                fill="#040000"
              />
              <path
                d="M41.2718 26.3224C40.1663 26.3224 38.9375 25.8114 37.9414 24.8517C36.3363 23.3037 35.9424 21.1731 37.0255 19.8947L39.1848 17.3286C40.3315 16.2227 42.6707 16.745 44.5094 18.5183C46.3481 20.2916 46.8896 22.5467 45.743 23.6535L45.7127 23.6799L43.0812 25.7369C42.5788 26.1329 41.9483 26.3233 41.2728 26.3233L41.2718 26.3224ZM39.7518 17.849L37.6325 20.3708C36.8046 21.3494 37.175 23.0463 38.4947 24.3191C39.8143 25.5918 41.5739 25.95 42.5876 25.1515L45.2034 23.1067C45.9933 22.3185 45.4263 20.4689 43.9571 19.0519C43.2034 18.325 42.3295 17.8103 41.4947 17.6029C40.742 17.4153 40.1242 17.503 39.7518 17.8499V17.849Z"
                fill="#040000"
              />
              <path
                d="M42.1894 20.6193C39.7452 18.2608 36.4302 17.6356 34.7834 19.2246L34.3974 19.6933C30.5986 18.8474 26.446 19.8517 23.4858 22.7081C18.9188 27.1149 18.9188 34.2611 23.4858 38.6679C28.0527 43.0747 35.4587 43.0747 40.0257 38.6679C42.986 35.8115 44.0268 31.8055 43.1501 28.139L43.6359 27.7665C45.2816 26.1784 44.6337 22.9788 42.1894 20.6202V20.6193Z"
                fill="#EFECF2"
              />
              <path
                d="M31.7563 42.3424C28.6611 42.3424 25.566 41.2061 23.2097 38.9324C20.9267 36.7295 19.6699 33.8005 19.6699 30.6857C19.6699 27.5709 20.9267 24.6418 23.2097 22.4389C26.1172 19.6334 30.2258 18.4584 34.2435 19.2722L34.5074 18.9563C36.3027 17.224 39.8728 17.8501 42.4656 20.351C43.7019 21.544 44.5424 22.9849 44.8297 24.4079C45.1287 25.8847 44.8023 27.172 43.912 28.031L43.8788 28.0593L43.5836 28.2857C44.427 32.1624 43.2093 36.126 40.3018 38.9324C37.9455 41.2061 34.8504 42.3424 31.7553 42.3424H31.7563ZM31.7318 19.7739C28.7716 19.7739 25.9159 20.8952 23.7629 22.9727C21.6275 25.0332 20.4518 27.7717 20.4518 30.6857C20.4518 33.5996 21.6275 36.3382 23.7629 38.3987C28.1705 42.6517 35.342 42.6517 39.7497 38.3987C42.5242 35.7214 43.653 31.9173 42.7695 28.2215L42.7138 27.9896L43.3745 27.4822C44.0645 26.8051 44.3088 25.765 44.0625 24.5513C43.8035 23.2744 43.0402 21.9721 41.9124 20.8838C39.6324 18.6838 36.5715 18.0548 35.0752 19.474L34.5494 20.1115L34.309 20.0578C33.4509 19.8663 32.586 19.773 31.7309 19.773L31.7318 19.7739Z"
                fill="#231815"
              />
              <path
                d="M31.7596 40.3384C37.2845 40.3384 41.7633 36.0166 41.7633 30.6855C41.7633 25.3544 37.2845 21.0327 31.7596 21.0327C26.2347 21.0327 21.7559 25.3544 21.7559 30.6855C21.7559 36.0166 26.2347 40.3384 31.7596 40.3384Z"
                fill="#E1E4E5"
              />
              <mask
                id="mask0_5873_625282"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="20"
                y="26"
                width="24"
                height="16"
              >
                <path d="M43.4533 26.1675H20.0625V41.9594H43.4533V26.1675Z" fill="white" />
              </mask>
              <g mask="url(#mask0_5873_625282)">
                <path
                  d="M31.7537 40.3388C37.2786 40.3388 41.7574 36.0171 41.7574 30.686C41.7574 25.3549 37.2786 21.0332 31.7537 21.0332C26.2288 21.0332 21.75 25.3549 21.75 30.686C21.75 36.0171 26.2288 40.3388 31.7537 40.3388Z"
                  fill="#1053BF"
                />
              </g>
              <mask
                id="mask1_5873_625282"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="20"
                y="26"
                width="24"
                height="16"
              >
                <path d="M43.4533 26.1675H20.0625V41.9594H43.4533V26.1675Z" fill="white" />
              </mask>
              <g mask="url(#mask1_5873_625282)">
                <mask
                  id="mask2_5873_625282"
                  style={{ maskType: 'luminance' }}
                  maskUnits="userSpaceOnUse"
                  x="21"
                  y="21"
                  width="21"
                  height="20"
                >
                  <path
                    d="M31.7381 40.3379C37.263 40.3379 41.7418 36.0162 41.7418 30.685C41.7418 25.3539 37.263 21.0322 31.7381 21.0322C26.2132 21.0322 21.7344 25.3539 21.7344 30.685C21.7344 36.0162 26.2132 40.3379 31.7381 40.3379Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask2_5873_625282)">
                  <path
                    d="M27.9859 39.5188C34.0197 39.5188 38.9112 34.7989 38.9112 28.9767C38.9112 23.1544 34.0197 18.4346 27.9859 18.4346C21.952 18.4346 17.0605 23.1544 17.0605 28.9767C17.0605 34.7989 21.952 39.5188 27.9859 39.5188Z"
                    fill="#3D81FA"
                  />
                </g>
              </g>
              <mask
                id="mask3_5873_625282"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="21"
                y="21"
                width="21"
                height="20"
              >
                <path
                  d="M31.7537 40.3379C37.2786 40.3379 41.7574 36.0162 41.7574 30.685C41.7574 25.3539 37.2786 21.0322 31.7537 21.0322C26.2288 21.0322 21.75 25.3539 21.75 30.685C21.75 36.0162 26.2288 40.3379 31.7537 40.3379Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask3_5873_625282)">
                <path
                  d="M25.5661 25.3929C29.8079 25.081 36.7259 28.7045 41.2804 25.7186C41.3063 26.3353 41.2055 26.9216 40.9976 27.472L23.5355 28.581C23.1565 27.9929 22.912 27.3508 22.8334 26.6677C22.8022 25.9594 24.3825 25.4802 25.5661 25.3929Z"
                  fill="#67BDFF"
                />
                <path
                  d="M38.7974 24.8769C39.9817 24.8145 40.9638 25.0478 41.6272 25.8013C41.6131 26.3687 41.4838 26.9223 41.259 27.4536L23.3769 28.5776C23.0603 27.9933 22.873 27.3617 22.8412 26.6947C24.5334 29.1519 34.5532 25.1018 38.7974 24.8769Z"
                  fill="#3D81FA"
                />
              </g>
              <path
                d="M41.6053 28.8447C39.6175 30.3828 36.6484 30.0254 34.5462 27.996C32.444 25.9675 32.0746 23.1035 33.6666 21.1864L35.072 19.4814C36.5683 18.0621 39.6292 18.6911 41.9092 20.8912C44.1893 23.0913 44.8421 26.0458 43.3703 27.4896L41.6043 28.8447H41.6053Z"
                fill="#EFECF2"
              />
              <path
                d="M36.5032 26.1083C34.4313 24.1091 33.7042 21.4875 34.6922 19.9419L33.6671 21.1857C32.074 23.1029 32.4444 25.9669 34.5466 27.9953C36.6488 30.0238 39.6179 30.3812 41.6057 28.8441L42.8928 27.8558C41.291 28.8092 38.5741 28.1076 36.5022 26.1083H36.5032Z"
                fill="#EFECF2"
              />
              <mask
                id="mask4_5873_625282"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="32"
                y="19"
                width="11"
                height="11"
              >
                <path
                  d="M36.5071 26.1025C34.4352 24.1033 33.7081 21.4817 34.6962 19.936L33.671 21.1799C32.0779 23.0971 32.4483 25.961 34.5505 27.9895C36.6527 30.0179 39.6218 30.3753 41.6096 28.8382L42.8967 27.8499C41.2949 28.8033 38.578 28.1017 36.5061 26.1025H36.5071Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask4_5873_625282)">
                <path
                  d="M39.4065 23.3054L32.375 30.0903L37.1274 34.6761L44.159 27.8912L39.4065 23.3054Z"
                  fill="#B0A4BC"
                />
              </g>
              <path
                d="M27.8036 28.023C28.6727 27.0509 28.7257 25.7206 27.9222 25.0519C27.1187 24.3831 25.7628 24.629 24.8938 25.6011C24.0248 26.5733 23.9717 27.9035 24.7752 28.5723C25.5788 29.2411 26.9346 28.9951 27.8036 28.023Z"
                fill="white"
              />
              <path
                d="M45.458 23.2576C46.4343 22.3155 45.8831 20.2541 44.2246 18.6547C42.5671 17.0553 40.4307 16.5225 39.4544 17.4646L37.3219 20.0032C36.4032 21.0887 36.6915 22.9898 38.2113 24.4562C39.731 25.9226 41.7022 26.2008 42.8261 25.3144L45.457 23.2567L45.458 23.2576Z"
                fill="#B16C3C"
              />
              <path
                d="M41.263 26.1964C40.1576 26.1964 38.9291 25.6853 37.9333 24.7253C36.3285 23.1769 35.9347 21.0456 37.0175 19.7669L39.1764 17.2C39.7511 16.6455 40.6404 16.4833 41.6803 16.7426C42.6478 16.984 43.6486 17.5687 44.4998 18.3891C46.3381 20.163 46.8795 22.4187 45.7332 23.5258L45.7029 23.5522L43.0719 25.6099C42.5696 26.0059 41.9392 26.1964 41.2639 26.1964H41.263ZM39.7423 17.7196L37.6235 20.2422C36.7957 21.221 37.1661 22.9185 38.4854 24.1916C39.8048 25.4647 41.564 25.823 42.5765 25.0243L45.1917 22.9788C45.9814 22.1914 45.4145 20.3402 43.9457 18.9219C43.1922 18.1949 42.3184 17.68 41.4838 17.4725C40.7313 17.2848 40.1136 17.3725 39.7413 17.7196H39.7423Z"
                fill="#231815"
              />
              <path
                d="M45.2732 22.8743C44.5227 23.5986 42.6472 23.0148 41.1793 21.5975C39.7114 20.1801 39.1055 18.3723 39.856 17.6471C40.6066 16.9229 42.4821 17.5066 43.95 18.924C45.4179 20.3404 46.0238 22.1491 45.2732 22.8743Z"
                fill="#DFB47E"
              />
            </g>
          </g>
          <g filter="url(#filter9_dd_5873_625282)">
            <path
              d="M17.2476 21.9525H17.096C16.7547 20.0866 16.2618 19.2926 14.5176 18.9353V18.7765C16.2997 18.4192 16.7926 17.5854 17.096 15.7593H17.2476C17.5889 17.6252 18.0818 18.4192 19.826 18.7765V18.9353C18.0439 19.2926 17.5511 20.1263 17.2476 21.9525Z"
              fill="#FCDB9F"
            />
          </g>
          <g filter="url(#filter10_dd_5873_625282)">
            <path
              d="M21.591 15.553H21.4998C21.2946 14.4309 20.9982 13.9534 19.9492 13.7386V13.6431C21.0209 13.4282 21.3173 12.9268 21.4998 11.8286H21.591C21.7962 12.9507 22.0926 13.4282 23.1416 13.6431V13.7386C22.0699 13.9534 21.7735 14.4548 21.591 15.553Z"
              fill="#FCDB9F"
            />
          </g>
          <g filter="url(#filter11_dd_5873_625282)">
            <path
              d="M34.9777 10.9666H34.8865C34.6813 9.8445 34.3849 9.36701 33.3359 9.15214V9.05666C34.4076 8.84179 34.7041 8.34038 34.8865 7.24219H34.9777C35.1829 8.3643 35.4793 8.84179 36.5283 9.05666V9.15214C35.4566 9.36701 35.1602 9.86842 34.9777 10.9666Z"
              fill="#FCDB9F"
            />
          </g>
          <g filter="url(#filter12_dd_5873_625282)">
            <path
              d="M45.9175 44.6952H45.7659C45.4247 42.8292 44.9318 42.0352 43.1875 41.6779V41.5192C44.9696 41.1619 45.4625 40.3281 45.7659 38.502H45.9175C46.2588 40.3679 46.7517 41.1619 48.496 41.5192V41.6779C46.7139 42.0352 46.221 42.869 45.9175 44.6952Z"
              fill="#FCDB9F"
            />
          </g>
          <defs>
            <filter
              id="filter0_f_5873_625282"
              x="10.6506"
              y="38.0339"
              width="42.6968"
              height="15.0587"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="1.18056" result="effect1_foregroundBlur_5873_625282" />
            </filter>
            <filter
              id="filter1_df_5873_625282"
              x="7.56292"
              y="16.8697"
              width="12.923"
              height="39.167"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4.72224" />
              <feGaussianBlur stdDeviation="2.36112" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.235294 0 0 0 0 0.713726 0 0 0 0 0.992157 0 0 0 0.2 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5873_625282" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5873_625282" result="shape" />
              <feGaussianBlur stdDeviation="0.59028" result="effect2_foregroundBlur_5873_625282" />
            </filter>
            <filter
              id="filter2_df_5873_625282"
              x="14.7817"
              y="1.81944"
              width="26.7706"
              height="53.937"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4.72224" />
              <feGaussianBlur stdDeviation="2.36112" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.235294 0 0 0 0 0.713726 0 0 0 0 0.992157 0 0 0 0.2 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5873_625282" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5873_625282" result="shape" />
              <feGaussianBlur stdDeviation="0.59028" result="effect2_foregroundBlur_5873_625282" />
            </filter>
            <filter
              id="filter3_df_5873_625282"
              x="8.81683"
              y="10.6861"
              width="45.9054"
              height="45.0708"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4.72224" />
              <feGaussianBlur stdDeviation="2.36112" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.235294 0 0 0 0 0.713726 0 0 0 0 0.992157 0 0 0 0.2 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5873_625282" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5873_625282" result="shape" />
              <feGaussianBlur stdDeviation="0.59028" result="effect2_foregroundBlur_5873_625282" />
            </filter>
            <filter
              id="filter4_df_5873_625282"
              x="34.5981"
              y="5.28282"
              width="17.3429"
              height="50.4742"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4.72224" />
              <feGaussianBlur stdDeviation="2.36112" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.235294 0 0 0 0 0.713726 0 0 0 0 0.992157 0 0 0 0.2 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5873_625282" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5873_625282" result="shape" />
              <feGaussianBlur stdDeviation="0.59028" result="effect2_foregroundBlur_5873_625282" />
            </filter>
            <filter
              id="filter5_df_5873_625282"
              x="44.2231"
              y="2.72764"
              width="11.4835"
              height="53.0293"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4.72224" />
              <feGaussianBlur stdDeviation="2.36112" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.235294 0 0 0 0 0.713726 0 0 0 0 0.992157 0 0 0 0.2 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5873_625282" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5873_625282" result="shape" />
              <feGaussianBlur stdDeviation="0.59028" result="effect2_foregroundBlur_5873_625282" />
            </filter>
            <filter
              id="filter6_df_5873_625282"
              x="12.02"
              y="8.14219"
              width="10.8624"
              height="47.6128"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4.72224" />
              <feGaussianBlur stdDeviation="2.36112" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.235294 0 0 0 0 0.713726 0 0 0 0 0.992157 0 0 0 0.2 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5873_625282" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5873_625282" result="shape" />
              <feGaussianBlur stdDeviation="0.59028" result="effect2_foregroundBlur_5873_625282" />
            </filter>
            <filter
              id="filter7_df_5873_625282"
              x="0.916645"
              y="34.9694"
              width="62.1706"
              height="23.114"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="3.54168" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.239216 0 0 0 0 0.505882 0 0 0 0 0.980392 0 0 0 1 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5873_625282" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5873_625282" result="shape" />
              <feGaussianBlur stdDeviation="0.15625" result="effect2_foregroundBlur_5873_625282" />
            </filter>
            <filter
              id="filter8_dd_5873_625282"
              x="13.0161"
              y="9.96774"
              width="39.9795"
              height="39.1563"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="3.32594" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.370833 0 0 0 0 0.548779 0 0 0 0 1 0 0 0 0.5 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5873_625282" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="3.32594" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.895 0 0 0 0 0.875 0 0 0 0 1 0 0 0 0.15 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_5873_625282" result="effect2_dropShadow_5873_625282" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_5873_625282" result="shape" />
            </filter>
            <filter
              id="filter9_dd_5873_625282"
              x="7.44995"
              y="8.69165"
              width="19.4439"
              height="20.3286"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="3.53381" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.945098 0 0 0 0 0.647059 0 0 0 0 0.0117647 0 0 0 1 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5873_625282" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="3.53381" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.988235 0 0 0 0 0.858824 0 0 0 0 0.623529 0 0 0 1 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_5873_625282" result="effect2_dropShadow_5873_625282" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_5873_625282" result="shape" />
            </filter>
            <filter
              id="filter10_dd_5873_625282"
              x="12.8816"
              y="4.76098"
              width="17.3267"
              height="17.8599"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="3.53381" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.945098 0 0 0 0 0.647059 0 0 0 0 0.0117647 0 0 0 1 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5873_625282" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="3.53381" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.988235 0 0 0 0 0.858824 0 0 0 0 0.623529 0 0 0 1 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_5873_625282" result="effect2_dropShadow_5873_625282" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_5873_625282" result="shape" />
            </filter>
            <filter
              id="filter11_dd_5873_625282"
              x="26.2683"
              y="0.174559"
              width="17.3267"
              height="17.8599"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="3.53381" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.945098 0 0 0 0 0.647059 0 0 0 0 0.0117647 0 0 0 1 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5873_625282" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="3.53381" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.988235 0 0 0 0 0.858824 0 0 0 0 0.623529 0 0 0 1 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_5873_625282" result="effect2_dropShadow_5873_625282" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_5873_625282" result="shape" />
            </filter>
            <filter
              id="filter12_dd_5873_625282"
              x="36.1199"
              y="31.4343"
              width="19.4439"
              height="20.3286"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="3.53381" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.945098 0 0 0 0 0.647059 0 0 0 0 0.0117647 0 0 0 1 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5873_625282" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="3.53381" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.988235 0 0 0 0 0.858824 0 0 0 0 0.623529 0 0 0 1 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_5873_625282" result="effect2_dropShadow_5873_625282" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_5873_625282" result="shape" />
            </filter>
            <radialGradient
              id="paint0_radial_5873_625282"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(31.9987 45.5632) rotate(90) scale(5.16817 18.987)"
            >
              <stop stopColor="#910DFD" />
              <stop offset="1" stopColor="#570897" />
            </radialGradient>
            <linearGradient
              id="paint1_linear_5873_625282"
              x1="14.0248"
              y1="46.5911"
              x2="14.0248"
              y2="18.0503"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.252988" stopColor="#910DFD" />
              <stop offset="0.839859" stopColor="#10B1FC" stopOpacity="0.3" />
              <stop offset="1" stopColor="#10B1FC" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_5873_625282"
              x1="28.1666"
              y1="46.3103"
              x2="28.1666"
              y2="3"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.252988" stopColor="#910DFD" />
              <stop offset="0.839859" stopColor="#10B1FC" stopOpacity="0.3" />
              <stop offset="1" stopColor="#10B1FC" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_5873_625282"
              x1="31.77"
              y1="46.3109"
              x2="31.77"
              y2="11.8667"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#910DFD" />
              <stop offset="0.576979" stopColor="#10B1FC" stopOpacity="0.2" />
              <stop offset="1" stopColor="#10B1FC" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_5873_625282"
              x1="43.2697"
              y1="46.3106"
              x2="43.2697"
              y2="6.46338"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.252988" stopColor="#910DFD" />
              <stop offset="0.839859" stopColor="#10B1FC" stopOpacity="0.3" />
              <stop offset="1" stopColor="#10B1FC" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_5873_625282"
              x1="49.9652"
              y1="46.3104"
              x2="49.9652"
              y2="3.9082"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.252988" stopColor="#910DFD" />
              <stop offset="0.839859" stopColor="#10B1FC" stopOpacity="0.3" />
              <stop offset="1" stopColor="#10B1FC" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_5873_625282"
              x1="17.4508"
              y1="46.3087"
              x2="17.4508"
              y2="9.32275"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.252988" stopColor="#910DFD" />
              <stop offset="0.839859" stopColor="#10B1FC" stopOpacity="0.3" />
              <stop offset="1" stopColor="#10B1FC" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_5873_625282"
              x1="32.0015"
              y1="51"
              x2="32.0015"
              y2="42.0527"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" />
              <stop offset="0.653903" stopColor="#B5EDFF" />
              <stop offset="1" stopColor="#5F9CFF" />
            </linearGradient>
            <clipPath id="clip0_5873_625282">
              <rect width="32.0001" height="30.8687" fill="white" transform="translate(17.0059 14.0522)" />
            </clipPath>
          </defs>
        </svg>
      )}
      {variant === ShampooIconVariant.NEWBIE_4_GAUGE && <img src={MagicPotion100Gauge} alt="Magic Potion 100 Gauge" />}
      {variant === ShampooIconVariant.NEWBIE_3_GAUGE && <img src={MagicPotion75Gauge} alt="Magic Potion 75 Gauge" />}
      {variant === ShampooIconVariant.NEWBIE_2_GAUGE && <img src={MagicPotion50Gauge} alt="Magic Potion 50 Gauge" />}
      {variant === ShampooIconVariant.NEWBIE_1_GAUGE && <img src={MagicPotion25Gauge} alt="Magic Potion 25 Gauge" />}
      {variant === ShampooIconVariant.NEWBIE_0_GAUGE && <img src={MagicPotion0Gauge} alt="Magic Potion 0 Gauge" />}
      {variant === ShampooIconVariant.OLDBIE_4_GAUGE && <img src={Potion100Gauge} alt="Potion 100 Gauge" />}
      {variant === ShampooIconVariant.OLDBIE_3_GAUGE && <img src={Potion75Gauge} alt="Potion 75 Gauge" />}
      {variant === ShampooIconVariant.OLDBIE_2_GAUGE && <img src={Potion50Gauge} alt="Potion 50 Gauge" />}
      {variant === ShampooIconVariant.OLDBIE_1_GAUGE && <img src={Potion25Gauge} alt="Potion 25 Gauge" />}
      {variant === ShampooIconVariant.OLDBIE_0_GAUGE && <img src={Potion0Gauge} alt="Potion 0 Gauge" />}
      {variant === ShampooIconVariant.HYPER_4 && <img src={DreamShampoo100} alt="Dream Potion 100" />}
      {variant === ShampooIconVariant.HYPER_3 && <img src={DreamShampoo75} alt="Dream Potion 75" />}
      {variant === ShampooIconVariant.HYPER_2 && <img src={DreamShampoo50} alt="Dream Potion 50" />}
      {variant === ShampooIconVariant.HYPER_1 && <img src={DreamShampoo25} alt="Dream Potion 25" />}
      {variant === ShampooIconVariant.HYPER_0 && <img src={DreamShampoo0} alt="Dream Potion 0" />}
      {variant === ShampooIconVariant.HYPER_4_GAUGE && <img src={Dream100Gauge} alt="Magic Potion 100 Gauge" />}
      {variant === ShampooIconVariant.HYPER_3_GAUGE && <img src={Dream75Gauge} alt="Magic Potion 75 Gauge" />}
      {variant === ShampooIconVariant.HYPER_2_GAUGE && <img src={Dream50Gauge} alt="Magic Potion 50 Gauge" />}
      {variant === ShampooIconVariant.HYPER_1_GAUGE && <img src={Dream25Gauge} alt="Magic Potion 25 Gauge" />}
      {variant === ShampooIconVariant.HYPER_0_GAUGE && <img src={Dream0Gauge} alt="Magic Potion 0 Gauge" />}

      {variant === ShampooIconVariant.LOADING_GAUGE && <img src={PotionLoadingGauge} alt="Potion Loading Gauge" />}
      {variant === ShampooIconVariant.ERROR_GAUGE && <img src={PotionErrorGauge} alt="Potion Error Gauge" />}
      {variant === ShampooIconVariant.HYPER_REFILL && <img src={DreamRefill} alt="Dream Potion Refill" />}
    </i>
  );
}

export default PotionIcon;
